/**
 * sidebarBindings.js — VRT presets, cinematic panel, W/L controls, tabs, modals, TF editor
 * Extracted from uiManager.js (декомпозиция God Object)
 */
// [11.1.10] Две строки ниже СТОЯЛИ ВНУТРИ докблока выше — между «/**» и «*/».
// Синтаксис от этого не страдает, файл разбирается, связывание проходит, но
// для браузера это комментарий: ни одно из шести имён не ввозилось. Падало на
// нажатии — «Вид А/Б», «А↔Б» и все кнопки сценариев умирали с ReferenceError,
// а getSidebarBindingsState ронял бы и проверку состояния (охрана «|| {}» от
// ReferenceError не спасает — до неё не доходит). Тот же род ошибки, что
// разобран в getSidebarBindingsState [11.0.2]: разбор проходит, падает вызов.
// Поймано tools/check_imports.mjs — ПОСЛЕ того, как его научили кириллице:
// прежде находка тонула в 141 ложной ошибке.
import { getWorkflow, getWindowPreset, CLINICAL_WORKFLOWS as CLINICAL_WORKFLOWS_РЕЕСТР } from '../core/presetsManager.js'; // [10.19.43] Сценарии; [11.0.2] реестр — под явным именем, чтобы его нельзя было спутать с местной копией, которой больше нет
import { setCameraA, setCameraB, toggleCameraAB, getCameraABState } from '../core/viewportCamera.js'; // [10.19.43] Ракурсы

import {  setWindowLevel, set3DPreset, applyRenderPreset, applyWindowToSlices, setStandardView, getRenderingEngine, getViewportIds, getVtkPlaneClass } from '../core/viewport.js';
import { setVolumeClipping } from '../core/viewportEffects.js';
import { getCinematicRenderer, find3DViewportId } from '../core/viewportState.js';
import { initTFEditor, toggleTFEditor, openWithPreset } from '../core/tfEditor.js';
// downloadBlob сюда не импортировался, а ниже стоит охрана
// `typeof downloadBlob === 'function'`. Необъявленное имя под typeof не падает —
// оно молча даёт 'undefined', охрана не пропускает, и снимок с записью
// кинематографического окна просто не сохранялись. Кнопка нажималась, кадр
// снимался, файла не появлялось и сообщения об ошибке тоже.
import { showToast, downloadBlob } from '../utils/helpers.js';
import { emit, on as busOn, EVENTS as BUS } from '../core/eventBus.js'; // [11.1.36] переприменение отсечения по событиям
import { callAPI } from '../core/viewerAPI.js';
import { updateWLOverlay } from './seriesPanel.js';
import { зажать, поКадрам, памятьОкна, подстроитьШкалу } from '../core/wlManual.js';   // [10.19.28] живой W/L и сброс; [11.1.17] шкала растёт под PET/авто
import { ГРУППЫ_ЧИПОВ, chipHtml, пределыШкалы } from '../core/wlChips.js';
import { setAnnotationStyle } from '../tools/toolManager.js';
import { setGlobalOpacityScale, setSoftTissueScale } from '../core/presets3d';
import { плоскостьОтсечения, плоскостьСоСтороны, плоскостиОкнаОбзора, маперПоддерживает } from '../core/tableCrop.js';
import { контрастыДляМодальности, аппаратыДляМодальности, маскаДаты, проверитьДату } from '../core/reportCatalogs.js'; // [11.1.31] справочники бланка // [11.1.26] «Убрать стол»
import { прочитатьБланк, прочитатьПрофили, сохранитьПрофиль, удалитьПрофиль, разобратьФайлПрофилей, собратьФайлПрофилей, записатьПрофили, ШРИФТЫ, шрифтыБланка, логотипБланка, поляБланка } from '../core/reportBlank.js'; // [11.1.23] «Плотность тканей» // [11.1.21] стиль аннотаций проведён к движку // [11.1.17] единый каталог чипов — оба грида строятся из него
import { changeLayout } from './layoutManager.js';
import { log } from '../utils/logger.js';
import { ModalManager } from './modalManager.js';

// [FIX] AbortController для очистки всех addEventListener при destroy
let _ac = new AbortController();


const $ = (id) => document.getElementById(id);
const $$ = (sel) => document.querySelectorAll(sel);
/**
 * [11.0.2] Привязка с меткой: элемент помнит, какие события у него уже заняты.
 *
 * Так возник дубль всей кинематики. Этот хелпер вешал слушателя молча, а
 * второй набор привязок (indexBindings) проверял `dataset.bound` — метку,
 * которой здесь никто не ставил, — видел «свободно» и вешал свой поверх.
 * Двадцать два контрола слушались дважды, и вина была не в том наборе, а
 * здесь: тот, кто пришёл первым, не оставил следа.
 *
 * Метка раздельная по событию (`bound-click`, `bound-change`): один и тот же
 * элемент законно слушает и клик, и ввод. Повтор пишется в отладку, а не
 * молчит: если два модуля правда спорят за кнопку, это надо видеть.
 */
const on = (id, evt, fn) => {
  const el = $(id);
  if (!el) return;
  const метка = `bound${evt.charAt(0).toUpperCase()}${evt.slice(1)}`;
  if (el.dataset[метка]) { log.debug(`[sidebarBindings] ${id}: «${evt}» уже привязан — второй слушатель не вешаю`); return; }
  el.addEventListener(evt, fn, { signal: _getSignal() });
  el.dataset[метка] = '1';
};
const onAll = (sel, evt, fn) => $$(sel).forEach(el => el.addEventListener(evt, fn, { signal: _getSignal() }));
let _abortController = null;
function _getSignal() { if (!_abortController) _abortController = new AbortController(); return _abortController.signal; }
export function destroySidebarBindings() {
  _ac.abort(); _ac = new AbortController(); if (_abortController) { _abortController.abort(); _abortController = null; } }

let _activeVRTPreset = '';
const BUILTIN_VRT_PRESETS = [
  // CT — основные
  { id: 'ct-bone-3d', name: 'Кости 3D', color: '#eea' },
  { id: 'ct-bone-context', name: 'Кости контекст', color: '#dd8' },
  { id: 'ct-bone-hard', name: 'Кости жёсткие', color: '#cc6' },
  { id: 'ct-bone-warm', name: 'Кости тёплые', color: '#fb8' },
  { id: 'ct-skin', name: 'Кожа', color: '#fca' },
  { id: 'ct-skin-transparent', name: 'Кожа прозр.', color: '#fdb' },
  { id: 'ct-muscle', name: 'Мышцы', color: '#a66' },
  { id: 'ct-vascular', name: 'Сосуды', color: '#f66' },
  { id: 'ct-vascular-bone', name: 'Сосуды+Кости', color: '#f86' },
  { id: 'ct-coronary', name: 'Коронары', color: '#e55' },
  { id: 'ct-air', name: 'Дых. пути', color: '#6cf' },
  { id: 'ct-lung-3d', name: 'Лёгкие 3D', color: '#66f' },
  { id: 'ct-lung-surface', name: 'Лёгкие поверхн.', color: '#88f' },
  { id: 'ct-colon', name: 'Кишечник', color: '#a64' },
  { id: 'ct-overview', name: 'Обзорный', color: '#aac' },
  { id: 'ct-xray', name: 'Рентген', color: '#bbb' },
  { id: 'ct-density-map', name: 'Карта плотности', color: '#8cf' },
  // MRI
  { id: 'mri-brain-3d', name: 'MRI Мозг', color: '#caa' },
  { id: 'mri-wm-gm', name: 'WM/GM', color: '#aaa' },
  // Кардио / Ангио
  { id: 'cardiac-3d', name: 'Сердце 3D', color: '#f48' },
  { id: 'cardiac-fat', name: 'Кардио жир', color: '#fa6' },
  { id: 'angio-3d', name: 'Ангио 3D', color: '#f88' },
  { id: 'fetus', name: 'Плод 3D', color: '#fac' },
  // Custom
  { id: 'custom-01-ct-liver', name: 'Печень', color: '#a86' },
  { id: 'custom-02-ct-kidneys', name: 'Почки', color: '#a68' },
  { id: 'custom-03-ct-fat', name: 'Жир', color: '#ee8' },
  { id: 'custom-04-ct-brain-vessels', name: 'Сосуды мозга', color: '#c8f' },
  { id: 'custom-05-ct-carotid', name: 'Сонные арт.', color: '#f8a' },
  { id: 'custom-06-ct-dental', name: 'Стоматология', color: '#efa' },
  { id: 'custom-07-ct-fracture', name: 'Переломы', color: '#fe8' },
  { id: 'custom-08-ct-mip-pseudo', name: 'Псевдо-MIP', color: '#8ef' },
  { id: 'custom-09-mri-angio', name: 'MRI Ангио', color: '#f8c' },
  { id: 'custom-10-mri-t2-fluid', name: 'MRI T2', color: '#8af' },
  { id: 'custom-11-ct-cardiac-valves', name: 'Клапаны', color: '#f68' },
  { id: 'custom-12-ct-pulmonary-vessels', name: 'Лёг. сосуды', color: '#68f' },
  { id: 'custom-13-ct-bronchi-lumen', name: 'Бронхи', color: '#6ef' },
  { id: 'custom-14-ct-aorta-stent', name: 'Аорта+стент', color: '#f46' },
  { id: 'custom-15-ct-muscle-skeletal', name: 'Мышцы+скелет', color: '#a86' },
];
let _ctx = null;

/**
 * @param {Object} ctx
 * @param {function():string} ctx.getCurrentViewportId
 * @param {Object} ctx.VRT_PRESET_MAP
 */
export function initSidebarBindings(ctx) {
  _bindРакурсы(); _bindСценарии(); // [10.19.43]
  _ctx = ctx;
  bindVRTSection();
  bindCinematicPanel();
  построитьЧипыОкон();   // [11.1.17] сперва отрисовать чипы из каталога — привязки ниже вешаются на живые узлы
  bindPresetChips();
  bindCustomWL();
  bindRightTabs();
  bindPanelCollapses();
  bindModals();
  bindSidebarToggles();
  bindSliderUpdates();
  bindToggles();
  bindTFEditor();
  bindLeftPanelVRT();
  bindLeftPanelOrient();
  bindRulerMinimap();
  bindHangingProtocols();
}

export { openModal, closeModal, bindTFEditor };

// ============================================================
// VRT & ВИД SECTION — 3D presets, orientations, cinematic, fit
// ============================================================
function bindVRTSection() {
  // Right panel: Standard views (ANT, SUP, POST, LEFT, INF, RIGHT)
  onAll('.preset-chip[data-std-view]', 'click', (e) => {
    const view = e.currentTarget.dataset.stdView;
    if (_ctx.getCurrentViewportId()) {
      setStandardView(_ctx.getCurrentViewportId(), view);
      // [10.19.14] Было «Anterior/Posterior/Superior» латиницей — теперь по-русски.
      const ПОРУССКИ = { anterior: 'Спереди', posterior: 'Сзади', superior: 'Сверху',
        inferior: 'Снизу', left: 'Слева', right: 'Справа' };
      showToast(ПОРУССКИ[view] || String(view), 'info', 800);
    }
  });

  // [10.19.16] Обработчик кнопки «btn-cinematic-toggle» переехал в ui/featureBindings.js:
  // все входы в кинематографический рендеринг теперь идут одним путём через
  // ui/cinematicControl.js. Здесь он был отдельным и вёл себя иначе — печатал
  // «включён», когда рендерер оставался выключенным.

  // Right panel: Fit View


  // Left panel: VRT preset buttons (colored)
  onAll('.sl-vrt-btn[data-render-preset]', 'click', (e) => {
    $$('.sl-vrt-btn').forEach(b => b.classList.remove('active'));
    $$('.preset-chip[data-render-preset]').forEach(b => b.classList.remove('active'));
    e.currentTarget.classList.add('active');
    const preset = e.currentTarget.dataset.renderPreset;
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: preset, ww: 400, wc: 40 };
    log.debug('[FIX-5] VRT preset:', preset, '→', p.cs3d);
    // [10.0.2] Пресет объёмной отрисовки — в объёмное окно, и только туда.
    // set3DPreset рядом больше не зовём: он бил в ПЕРВОЕ объёмное окно, а в
    // раскладке из шести адресат — «3D · Пресет», иначе оба окна становились
    // одинаковыми и вторая панель теряла смысл.
    _последнийVRTПресет = { cs3d: p.cs3d, ww: p.ww, wc: p.wc };   // [11.1.23] для пере-применения слайдером плотности
    const r = applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
    showToast(_presetToast(e.currentTarget.textContent, r), 'info', 1200);
    // [11.0.2] Пресет переписал кривую прозрачности — значит ползунки «Объём
    // 3D» показывают уже не то, что на экране. Подтягиваем их под новую
    // кривую, иначе подпись врёт (см. оговорку в _подключитьОбъём3D).
    setTimeout(() => window.__волОбъёмСнятьСКривой?.(), 120);
  });

  // Right panel + mobile: preset-chip 3D render presets
  onAll('.preset-chip[data-render-preset]', 'click', (e) => {
    $$('.sl-vrt-btn[data-render-preset]').forEach(b => b.classList.remove('active'));
    $$('.preset-chip[data-render-preset]').forEach(b => b.classList.remove('active'));
    e.currentTarget.classList.add('active');
    const preset = e.currentTarget.dataset.renderPreset;
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: preset, ww: 400, wc: 40 };
    log.debug('[FIX-5] VRT preset (chip):', preset, '→', p.cs3d);
    _последнийVRTПресет = { cs3d: p.cs3d, ww: p.ww, wc: p.wc };   // [11.1.23]
    const r2 = applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
    showToast(_presetToast(e.currentTarget.textContent, r2), 'info', 1200);
    setTimeout(() => window.__волОбъёмСнятьСКривой?.(), 120);   // [11.0.2] см. выше
  });

  // Left panel: Orientation buttons
  onAll('.sl-orient-btn[data-std-view]', 'click', (e) => {
    const view = e.currentTarget.dataset.stdView;
    if (_ctx.getCurrentViewportId()) {
      setStandardView(_ctx.getCurrentViewportId(), view);
      showToast(`📷 ${view.charAt(0).toUpperCase() + view.slice(1)}`, 'info', 800);
    }
  });

  // [10.19.16] Обработчик кнопки «btn-cinematic-left» переехал в ui/featureBindings.js:
  // все входы в кинематографический рендеринг теперь идут одним путём через
  // ui/cinematicControl.js. Здесь он был отдельным и вёл себя иначе — печатал
  // «включён», когда рендерер оставался выключенным.

  // [10.19.16] «Вписать» была молчаливой пустышкой.
  //
  // Прежний код брал ТОЛЬКО активное окно: `re.getViewport(getCurrentViewportId())`.
  // Пока врач не щёлкнул по какому-нибудь окну, активного окна нет — идентификатор
  // пустой, `getViewport(undefined)` возвращает ничего, и обработчик молча
  // заканчивался. Измерено на живой сборке: камера не менялась, плашек ноль.
  // Именно про эту кнопку сказано «пустышка», и это была правда.
  //
  // Теперь: если активное окно есть — вписывается оно, иначе ВСЕ окна раскладки.
  // И кнопка всегда отвечает числом, сколько окон вписала.
  on('btn-fit-view-left', 'click', () => {
    const re = getRenderingEngine();
    if (!re) { showToast('Сначала откройте исследование — вписывать нечего', 'warning', 3000); return; }
    const активное = _ctx.getCurrentViewportId?.();
    const цели = активное ? [активное] : (getViewportIds() || []);
    let вписано = 0;
    for (const id of цели) {
      try {
        const vp = re.getViewport(id);
        if (!vp) continue;
        vp.resetCamera();
        vp.render();
        вписано++;
      } catch (e) { log.debug('[Вписать]', e.message); }
    }
    if (!вписано) { showToast('Вписывать нечего: в раскладке нет окон с изображением', 'warning', 3000); return; }
    showToast(активное ? 'Изображение вписано в активное окно' : `Изображение вписано во все окна: ${вписано}`, 'info', 2000);
  });

  // VRT Preset Manager
  on('btn-vrt-manager', 'click', () => {
    openVRTPresetManager();
    openModal('modal-vrt-presets');
  });

  // [10.0.13] «3D пресет» разворачивает ШЕСТОЕ окно MPR 6 во весь экран.
  //
  // Раньше кнопка строила своё одиночное объёмное окно и сама ставила туда
  // пресет. Трижды подряд оно чем-то отличалось от рабочего шестого окна, и
  // на МР выходил полупрозрачный блок вместо головы. Своего пути больше нет:
  // кнопка показывает тот самый вьюпорт, а не его копию.
  on('btn-preset-3d', 'click', () => {
    window.MikhmelViewer?.showPreset3DFullscreen?.();
  });
}

// ============================================================
// CINEMATIC PANEL — полная панель управления Cinematic Rendering
// ============================================================
function bindCinematicPanel() {
  // ═══ Кешированный renderer ═══
  let _crCache = null;
  
  const getCR = () => {
    if (_crCache) return _crCache;
    try { const cr = getCinematicRenderer(); if (cr && typeof cr.setParams === 'function') { _crCache = cr; return cr; } } catch (e) { log.debug("[sidebarBindings]", e.message); }
    return null;
  };
  
  const getCRAsync = async () => {
    if (_crCache) return _crCache;
    try {
      const cr = await window.MikhmelViewer?._getCinematicRenderer?.();
      if (cr && typeof cr.setParams === 'function') { _crCache = cr; return cr; }
    } catch (e) { log.debug("[sidebarBindings]", e.message); }
    return null;
  };

  // Гарантированный toggle через API (cinematicToggle всегда работает)
  /**
   * [11.0.2] Обработчик кнопки «Включить/Выключить» (cine-toggle-btn) УДАЛЁН:
   * такой кнопки нет в разметке с 10.19.19.
   *
   * Тогда её заменили честной парой «Рендер» / «Стоп» (btn-render-start,
   * btn-render-stop): у двух явных кнопок нет состояния, которым можно
   * соврать, а одна переключающаяся врала — показывала «Выключить», когда
   * включение не удалось. Кнопку убрали, а сорок пять строк её обработчика
   * остались висеть здесь вместе с помощником ensureToggle: код исполнялся при
   * каждом запуске, искал элемент, не находил и молча выходил.
   *
   * Сторож не ловил это по правилу «код сам создаёт элемент»: имя лежало в
   * массиве подписей _syncUI (indexBindings) как `id: '…'`, и запись в объекте
   * принималась за создание. Дыра закрыта в uiwiring_test [11.0.2].
   */

  // Preset selector
  on('cine-preset', 'change', async () => {
    const sel = $('cine-preset');
    if (!sel) return;
    let cr = getCR() || await getCRAsync();
    if (cr) {
      cr.setPreset(sel.value);
    } else {
      try { await window.MikhmelViewer?.cinematicPreset?.(sel.value); } catch (e) { log.debug("[sidebarBindings]", e.message); }
    }
    showToast(`🎬 ${sel.options[sel.selectedIndex].text}`, 'info', 800);
    setTimeout(() => _syncCinematicSliders(), 50);
  });

  // Slider helper
  function bindSlider(sliderId, valId, realMin, realMax, decimals, setFn) {
    const slider = $(sliderId);
    const valEl = $(valId);
    if (!slider) return;
    slider.addEventListener('input', () => {
      const pct = parseFloat(slider.value);
      const range = parseFloat(slider.max) - parseFloat(slider.min);
      const real = realMin + (pct - parseFloat(slider.min)) / range * (realMax - realMin);
      if (valEl) valEl.textContent = real.toFixed(decimals);
      setFn(real);
    }, { signal: _ac.signal });
  }

  // Param setter — sync с async fallback
  const setP = (path, val) => {
    const apply = (cr) => {
      const parts = path.split('.');
      const obj = {};
      let cur = obj;
      for (let i = 0; i < parts.length - 1; i++) { cur[parts[i]] = {}; cur = cur[parts[i]]; }
      cur[parts[parts.length - 1]] = val;
      cr.setParams(obj);
    };
    const cr = getCR();
    if (cr) { apply(cr); return; }
    getCRAsync().then(asyncCr => { if (asyncCr) apply(asyncCr); });
  };

  // Bind all sliders
  bindSlider('cine-ssao-radius', 'cine-ssao-radius-val', 1, 20, 0, v => setP('ssao.radius', v));
  bindSlider('cine-ssao-intensity', 'cine-ssao-intensity-val', 0, 1, 2, v => setP('ssao.intensity', v));
  bindSlider('cine-ssao-samples', 'cine-ssao-samples-val', 4, 32, 0, v => setP('ssao.samples', Math.round(v)));
  bindSlider('cine-bloom-threshold', 'cine-bloom-threshold-val', 0, 1, 2, v => setP('bloom.threshold', v));
  bindSlider('cine-bloom-intensity', 'cine-bloom-intensity-val', 0, 1, 2, v => setP('bloom.intensity', v));
  bindSlider('cine-exposure', 'cine-exposure-val', 0.5, 3, 1, v => setP('toneMap.exposure', v));
  bindSlider('cine-gamma', 'cine-gamma-val', 1, 3, 1, v => setP('toneMap.gamma', v));
  bindSlider('cine-sharpen', 'cine-sharpen-val', 0, 1, 2, v => setP('sharpen', v));
  bindSlider('cine-vignette', 'cine-vignette-val', 0, 1, 2, v => setP('vignette.intensity', v));
  bindSlider('cine-saturation', 'cine-saturation-val', 0, 2, 2, v => setP('colorGrade.saturation', v));
  bindSlider('cine-contrast', 'cine-contrast-val', 0.5, 2, 2, v => setP('colorGrade.contrast', v));
  bindSlider('cine-temperature', 'cine-temperature-val', -1, 1, 1, v => setP('colorGrade.temperature', v));
  bindSlider('cine-dof', 'cine-dof-val', 0, 1, 2, v => setP('dof.intensity', v));
  bindSlider('cine-dof-focus', 'cine-dof-focus-val', 0, 1, 2, v => setP('dof.focus', v));
  bindSlider('cine-edge', 'cine-edge-val', 0, 1, 2, v => setP('edge.intensity', v));
  bindSlider('cine-chromab', 'cine-chromab-val', 0, 1, 2, v => setP('chromAb', v));
  bindSlider('cine-grain', 'cine-grain-val', 0, 1, 2, v => setP('grain', v));

  // [ENTERPRISE v8] SSR
  bindSlider('cine-ssr-intensity', 'cine-ssr-intensity-val', 0, 1, 2, v => setP('ssr.intensity', v));
  bindSlider('cine-ssr-roughness', 'cine-ssr-roughness-val', 0, 1, 2, v => setP('ssr.roughness', v));
  bindSlider('cine-ssr-dist', 'cine-ssr-dist-val', 5, 60, 0, v => setP('ssr.maxDist', v));

  // [ENTERPRISE v8] Volumetric Fog
  bindSlider('cine-fog-density', 'cine-fog-density-val', 0, 0.5, 2, v => setP('fog.density', v));
  bindSlider('cine-fog-falloff', 'cine-fog-falloff-val', 0.5, 5, 1, v => setP('fog.falloff', v));
  bindSlider('cine-fog-height', 'cine-fog-height-val', 0, 1, 2, v => setP('fog.height', v));

  // [ENTERPRISE v8] Color LUT
  on('cine-lut-mode', 'change', () => {
    const sel = $('cine-lut-mode');
    if (sel) setP('lut.mode', parseInt(sel.value));
  });
  bindSlider('cine-lut-intensity', 'cine-lut-intensity-val', 0, 1, 2, v => setP('lut.intensity', v));

  // [ENTERPRISE v8] Bokeh DOF
  bindSlider('cine-bokeh-size', 'cine-bokeh-size-val', 0.1, 1, 2, v => setP('bokeh.size', v));
  bindSlider('cine-bokeh-bright', 'cine-bokeh-bright-val', 0, 5, 1, v => setP('bokeh.bright', v));

  // Tone map mode
  on('cine-tonemap', 'change', () => {
    const sel = $('cine-tonemap');
    if (sel) setP('toneMap.mode', parseInt(sel.value));
  });

  // Split compare
  const splitSlider = $('cine-split');
  const splitVal = $('cine-split-val');
  if (splitSlider) {
    splitSlider.addEventListener('input', async () => {
      const v = parseFloat(splitSlider.value) / 100;
      if (splitVal) splitVal.textContent = Math.round(v * 100) + '%';
      const cr = getCR() || await getCRAsync();
      if (cr) cr.setSplitCompare(v);
    }, { signal: _ac.signal });
  }

  /**
   * [11.0.2] Распаковка ответа рендерера.
   *
   * Он отвечает не значением, а обёрткой `{ success, value }` либо
   * `{ success: false, error }` (cinematicRendering.js:51) — так у него
   * устроены все 33 возврата. Скриншот и запись брали ответ как есть и
   * отдавали обёртку в downloadBlob. Там охрана `!blob || blob.size === 0`
   * обёртку пропускала (`size` у неё нет вовсе), и URL.createObjectURL падал
   * с TypeError. Файл не сохранялся НИКОГДА, а на экране не было даже ошибки:
   * исключение уходило в необработанный промис.
   */
  const развернуть = (ответ) => {
    if (ответ instanceof Blob) return { ok: true, blob: ответ };            // на случай, если метод вернёт напрямую
    if (ответ && typeof ответ === 'object' && 'success' in ответ) {
      return ответ.success ? { ok: true, blob: ответ.value } : { ok: false, причина: ответ.error || 'причина не названа' };
    }
    return { ok: false, причина: 'рендерер ответил непонятным значением' };
  };

  // Screenshot
  on('cine-screenshot-btn', 'click', async () => {
    const cr = getCR() || await getCRAsync();
    if (!cr) { showToast('🎬 Кинематографический рендеринг не активен', 'warning', 1500); return; }
    const р = развернуть(await cr.captureScreenshot({ watermark: 'Mikhmel DICOM Viewer' }));
    if (!р.ok) { showToast(`📷 Снимок не сделан: ${р.причина}`, 'error', 3000); return; }
    if (!(р.blob instanceof Blob) || р.blob.size === 0) { showToast('📷 Снимок вышел пустым — кадр ещё не готов', 'warning', 3000); return; }
    downloadBlob(р.blob, `cinematic_${Date.now()}.png`);
    showToast('📷 Скриншот сохранён', 'success', 1500);
  });

  // Record
  on('cine-record-btn', 'click', async () => {
    const cr = getCR() || await getCRAsync();
    if (!cr) { showToast('🎬 Кинематографический рендеринг не активен', 'warning', 1500); return; }
    const btn = $('cine-record-btn');
    if (cr.isRecording()) {
      const р = развернуть(await cr.stopRecording());
      if (btn) btn.textContent = '🔴 Запись';
      if (!р.ok) { showToast(`🎬 Запись не сохранена: ${р.причина}`, 'error', 3000); return; }
      if (!(р.blob instanceof Blob) || р.blob.size === 0) { showToast('🎬 Записывать было нечего — файл пуст', 'warning', 3000); return; }
      downloadBlob(р.blob, `cinematic_${Date.now()}.webm`);
      showToast('🎬 Видео сохранено', 'success', 1500);
    } else {
      // Старт тоже отвечает обёрткой: «уже пишем», «нет канвы», «MediaRecorder
      // не поддержан». Раньше ответ выбрасывался, кнопка меняла подпись на
      // «Стоп» — и человек считал, что запись идёт, когда она не началась.
      const старт = cr.startRecording();
      if (старт && старт.success === false) {
        showToast(`🎬 Запись не началась: ${старт.error || 'причина не названа'}`, 'error', 3000);
        return;
      }
      if (btn) btn.textContent = '⏹ Стоп';
      showToast('🔴 Запись...', 'info', 1500);
    }
  });
}

// Синхронизация ползунков панели с текущими параметрами CinematicRenderer
async function _syncCinematicSliders() {
  try {
    let cr = getCinematicRenderer();
    if (!cr) {
      try { cr = await window.MikhmelViewer?._getCinematicRenderer?.(); } catch (e) { log.debug("[sidebarBindings]", e.message); }
    }
    if (!cr) return;
    const p = cr.getParams();
    const set = (id, val, display) => {
      const el = document.getElementById(id);
      const valEl = document.getElementById(id + '-val');
      if (el) el.value = val;
      if (valEl) valEl.textContent = display;
    };
    if (p.ssao) {
      set('cine-ssao-radius', p.ssao.radius || 8, p.ssao.radius || 8);
      set('cine-ssao-intensity', Math.round((p.ssao.intensity || 0) * 100), (p.ssao.intensity || 0).toFixed(2));
      set('cine-ssao-samples', p.ssao.samples || 16, p.ssao.samples || 16);
    }
    if (p.bloom) {
      set('cine-bloom-threshold', Math.round((p.bloom.threshold || 0) * 100), (p.bloom.threshold || 0).toFixed(2));
      set('cine-bloom-intensity', Math.round((p.bloom.intensity || 0) * 100), (p.bloom.intensity || 0).toFixed(2));
    }
    if (p.toneMap) {
      const tmSel = document.getElementById('cine-tonemap');
      if (tmSel) tmSel.value = String(p.toneMap.mode || 0);
      set('cine-exposure', Math.round((p.toneMap.exposure || 1) / 3 * 300), (p.toneMap.exposure || 1).toFixed(1));
      set('cine-gamma', Math.round((p.toneMap.gamma || 2.2) / 3 * 300), (p.toneMap.gamma || 2.2).toFixed(1));
    }
    set('cine-sharpen', Math.round((p.sharpen || 0) * 100), (p.sharpen || 0).toFixed(2));
    if (p.vignette) set('cine-vignette', Math.round((p.vignette.intensity || 0) * 100), (p.vignette.intensity || 0).toFixed(2));
    if (p.colorGrade) {
      set('cine-saturation', Math.round((p.colorGrade.saturation || 1) * 100), (p.colorGrade.saturation || 1).toFixed(2));
      set('cine-contrast', Math.round(((p.colorGrade.contrast || 1) - 0.5) / 1.5 * 150 + 50), (p.colorGrade.contrast || 1).toFixed(2));
      set('cine-temperature', Math.round((p.colorGrade.temperature || 0) * 100), (p.colorGrade.temperature || 0).toFixed(1));
    }
    if (p.dof) {
      set('cine-dof', Math.round((p.dof.intensity || 0) * 100), (p.dof.intensity || 0).toFixed(2));
      set('cine-dof-focus', Math.round((p.dof.focus || 0.5) * 100), (p.dof.focus || 0.5).toFixed(2));
    }
    if (p.edge) set('cine-edge', Math.round((p.edge.intensity || 0) * 100), (p.edge.intensity || 0).toFixed(2));
    set('cine-chromab', Math.round((p.chromAb || 0) * 100), (p.chromAb || 0).toFixed(2));
    set('cine-grain', Math.round((p.grain || 0) * 100), (p.grain || 0).toFixed(2));
    // [ENTERPRISE v8] SSR
    if (p.ssr) {
      set('cine-ssr-intensity', Math.round((p.ssr.intensity || 0) * 100), (p.ssr.intensity || 0).toFixed(2));
      set('cine-ssr-roughness', Math.round((p.ssr.roughness ?? 0.5) * 100), (p.ssr.roughness ?? 0.5).toFixed(2));
      set('cine-ssr-dist', p.ssr.maxDist || 30, p.ssr.maxDist || 30);
    }
    // [ENTERPRISE v8] Fog
    if (p.fog) {
      set('cine-fog-density', Math.round((p.fog.density || 0) * 200), (p.fog.density || 0).toFixed(2));
      set('cine-fog-falloff', Math.round((p.fog.falloff ?? 2) / 5 * 500), (p.fog.falloff ?? 2).toFixed(1));
      set('cine-fog-height', Math.round((p.fog.height ?? 0.3) * 100), (p.fog.height ?? 0.3).toFixed(2));
    }
    // [ENTERPRISE v8] LUT
    if (p.lut) {
      const lutSel = document.getElementById('cine-lut-mode');
      if (lutSel) lutSel.value = String(p.lut.mode || 0);
      set('cine-lut-intensity', Math.round((p.lut.intensity || 0) * 100), (p.lut.intensity || 0).toFixed(2));
    }
    // [ENTERPRISE v8] Bokeh
    if (p.bokeh) {
      set('cine-bokeh-size', Math.round((p.bokeh.size ?? 0.5) * 100), (p.bokeh.size ?? 0.5).toFixed(2));
      set('cine-bokeh-bright', Math.round((p.bokeh.bright ?? 2) / 5 * 500), (p.bokeh.bright ?? 2).toFixed(1));
    }
  } catch(e) { log.warn('[Cinematic] Sync sliders:', e.message); }
}

function getUserVRTPresets() {
  try { return JSON.parse(localStorage.getItem('vrt-user-presets') || '[]'); }
  catch(e) { log.debug('[Sidebar] getPresetKeys:', e.message); return []; }
}

function saveUserVRTPresets(presets) {
  try { localStorage.setItem('vrt-user-presets', JSON.stringify(presets)); } catch (e) { log.debug('[SidebarBindings]', e.message); }
}

function openVRTPresetManager() {
  const listEl = $('vrt-preset-list');
  const userListEl = $('vrt-user-preset-list');
  const countEl = $('vrt-preset-count');
  const currentEl = $('vrt-current-name');

  if (currentEl) currentEl.textContent = _activeVRTPreset || '—';

  // Встроенные
  if (listEl) {
    listEl.innerHTML = BUILTIN_VRT_PRESETS.map(p => `
      <div class="vrt-preset-item ${_activeVRTPreset === p.id ? 'active' : ''}" data-vrt-id="${p.id}">
        <span class="vrt-dot" style="background:${p.color}"></span>
        <span class="vrt-name">${p.name}</span>
      </div>`).join('');

    listEl.querySelectorAll('.vrt-preset-item').forEach(el => {
      el.onclick = () => {
        const id = el.dataset.vrtId;
        _activeVRTPreset = id;
        set3DPreset(id);
        // Обновляем UI
        listEl.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
        userListEl?.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
        el.classList.add('active');
        if (currentEl) currentEl.textContent = el.querySelector('.vrt-name')?.textContent || id;
        showToast(`🎨 ${el.querySelector('.vrt-name')?.textContent}`, 'info', 800);
      };
    });
  }

  // Пользовательские
  const userPresets = getUserVRTPresets();
  if (userListEl) {
    if (userPresets.length === 0) {
      userListEl.innerHTML = '<div style="padding:12px;text-align:center;color:var(--text-dim);font-size:11px;grid-column:1/-1;">Нет сохранённых пресетов</div>';
    } else {
      userListEl.innerHTML = userPresets.map((p, i) => `
        <div class="vrt-preset-item ${_activeVRTPreset === p.id ? 'active' : ''}" data-vrt-user-idx="${i}">
          <span class="vrt-dot" style="background:${p.color || '#888'}"></span>
          <span class="vrt-name">${p.name}</span>
          <span class="vrt-del" data-vrt-del="${i}" title="Удалить">✕</span>
        </div>`).join('');

      userListEl.querySelectorAll('.vrt-preset-item').forEach(el => {
        el.onclick = (e) => {
          if (e.target.classList.contains('vrt-del')) return;
          const idx = parseInt(el.dataset.vrtUserIdx);
          const p = userPresets[idx];
          if (!p) return;
          _activeVRTPreset = p.id;
          // Применяем сохранённые WW/WC + 3D preset
          if (p.cs3dPreset) set3DPreset(p.cs3dPreset);
          // Здесь ww/wc — самостоятельная часть пользовательского пресета,
          // а не довесок к объёмному: её место действительно на срезах.
          if (p.ww && p.wc) applyWindowToSlices({ ww: p.ww, wc: p.wc });
          listEl?.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
          userListEl.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
          el.classList.add('active');
          if (currentEl) currentEl.textContent = p.name;
          showToast(`🎨 ${p.name}`, 'info', 800);
        };
      });

      // Delete buttons
      userListEl.querySelectorAll('.vrt-del').forEach(btn => {
        btn.onclick = (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.dataset.vrtDel);
          if (!confirm(`Удалить пресет "${userPresets[idx]?.name}"?`)) return;
          userPresets.splice(idx, 1);
          saveUserVRTPresets(userPresets);
          openVRTPresetManager(); // Обновляем
          showToast('🗑️ Пресет удалён', 'info');
        };
      });
    }
  }

  if (countEl) countEl.textContent = `${BUILTIN_VRT_PRESETS.length} + ${userPresets.length} польз.`;

  // Save form
  const saveBtn = $('vrt-btn-save-current');
  const saveForm = $('vrt-save-form');
  const doSaveBtn = $('vrt-btn-do-save');
  const cancelSaveBtn = $('vrt-btn-cancel-save');

  if (saveBtn) saveBtn.onclick = () => { if (saveForm) saveForm.style.display = ''; };
  if (cancelSaveBtn) cancelSaveBtn.onclick = () => { if (saveForm) saveForm.style.display = 'none'; };
  if (doSaveBtn) doSaveBtn.onclick = () => {
    const nameInput = $('vrt-new-name');
    const colorInput = $('vrt-new-color');
    const name = nameInput?.value?.trim();
    if (!name) { showToast('⚠️ Введите название', 'warning'); return; }

    // Считываем текущие WW/WC из viewport
    const re = getRenderingEngine();
    const vp = re?.getViewport(_ctx.getCurrentViewportId());
    let ww = 400, wc = 40;
    try {
      const voiRange = vp?.getProperties?.()?.voiRange;
      if (voiRange) {
        ww = Math.round(voiRange.upper - voiRange.lower);
        wc = Math.round((voiRange.upper + voiRange.lower) / 2);
      }
    } catch (e) { log.debug('[SidebarBindings]', e.message); }

    const newPreset = {
      id: 'user_' + Date.now(),
      name: name,
      color: colorInput?.value || '#888',
      cs3dPreset: _activeVRTPreset || '',
      ww, wc,
      created: new Date().toISOString()
    };

    const presets = getUserVRTPresets();
    presets.push(newPreset);
    saveUserVRTPresets(presets);
    if (saveForm) saveForm.style.display = 'none';
    if (nameInput) nameInput.value = '';
    openVRTPresetManager();
    showToast(`💾 Пресет "${name}" сохранён`, 'success');
  };

  // Export / Import
  const exportBtn = $('vrt-btn-export');
  if (exportBtn) exportBtn.onclick = () => {
    const data = JSON.stringify(getUserVRTPresets(), null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'vrt-presets.json';
    a.click();
    showToast('📤 Экспортировано', 'success');
  };

  const importBtn = $('vrt-btn-import');
  if (importBtn) importBtn.onclick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async () => {
      try {
        const text = await input.files[0].text();
        const imported = JSON.parse(text);
        if (!Array.isArray(imported)) throw new Error('Invalid format');
        const existing = getUserVRTPresets();
        const merged = [...existing, ...imported.map(p => ({ ...p, id: 'user_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6) }))];
        saveUserVRTPresets(merged);
        openVRTPresetManager();
        showToast(`📥 Импортировано ${imported.length} пресетов`, 'success');
      } catch(e) {
        showToast('❌ Ошибка импорта: ' + e.message, 'error');
      }
    };
    input.click();
  };
}

// ============================================================
// W/L PRESETS
// ============================================================
// ============================================================
// W/L PRESETS
// ============================================================
/**
 * [11.1.17] Оба грида — правая панель и мобильный ящик — рендерятся из
 * ЕДИНОГО каталога core/wlChips.js. Две рукописные копии разъехались
 * (аудит §2.2: в мобильном пропали Средостение, Височная кость, Таз, PET,
 * US, рентген-Кости/Мягк. и «Ангио (кино)» с авто-окном); теперь дрейф
 * невозможен по построению, а «Ангио (кино)» впервые доступно с телефона.
 */
function построитьЧипыОкон() {
  for (const г of ГРУППЫ_ЧИПОВ) {
    for (const суффикс of ['', '-m']) {
      const узел = $('wl-grid-' + г.ключ + суффикс);
      if (узел) узел.innerHTML = г.чипы.map(chipHtml).join('');
    }
  }
}

function bindPresetChips() {
  // [11.1.17] Обработчик ОДИН на оба сорта чипов. Раньше их было два
  // независимых onAll ([data-ww] и [data-wl-auto]); чип, несущий оба атрибута
  // (МРТ: авто + затравка), стрелял бы дважды — та же порода, что двойной
  // «Снимок экрана» из 11.1.16. Ветвление внутри одного слушателя закрывает
  // ловушку по построению.
  const отметить = (чип) => {
    $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => {
      c.classList.remove('active');
      c.setAttribute('aria-pressed', 'false');   // [11.1.17] аудит §2.5
    });
    чип.classList.add('active');
    чип.setAttribute('aria-pressed', 'true');
  };

  onAll('.preset-chip[data-ww], .preset-chip[data-wl-auto]', 'click', async (e) => {
    const чип = e.currentTarget;   // до await: после него currentTarget пуст
    if (чип.dataset.wlAuto) {
      // [10.3.2] Окно не табличное — по 1–99 перцентилю яркости кадра.
      const { autoWindowFromFrame } = await import('./seriesPanel.js');
      const w = autoWindowFromFrame();
      if (w) {
        applyWindowToSlices({ ww: w.ww, wc: w.wc });
        отметить(чип);
        updateWLOverlay(w.ww, w.wc);
        showToast(`${чип.textContent} (авто по кадру): W:${w.ww} L:${w.wc}`, 'success', 1500);
        return;
      }
      // [11.1.17] Затравка (аудит §2.3): у МРТ-чипов есть типовые числа —
      // применяем их С ОГОВОРКОЙ, пока кадр не готов. У XA затравки нет
      // нарочно (типовых чисел у съёмки с С-дуги не существует) — прежний
      // честный отказ.
      const ww = parseInt(чип.dataset.ww), wc = parseInt(чип.dataset.wc);
      if (Number.isFinite(ww) && Number.isFinite(wc)) {
        applyWindowToSlices({ ww, wc });
        отметить(чип);
        updateWLOverlay(ww, wc);
        showToast(`Кадр не готов — применены типовые ${чип.textContent}: W:${ww} L:${wc}. Нажмите ещё раз для авто-окна`, 'warning', 3000);
      } else {
        showToast('Кадр ещё не загружен — подождите секунду и нажмите снова', 'warning', 2500);
      }
      return;
    }
    const ww = parseInt(чип.dataset.ww);
    const wc = parseInt(чип.dataset.wc);
    // Окно плотности — на срезовые окна. Это самостоятельный пресет окна,
    // а не довесок к объёмному, и адресат у него именно срезы.
    applyWindowToSlices({ ww, wc });
    отметить(чип);
    updateWLOverlay(ww, wc);
    showToast(`W:${ww} L:${wc}`, 'info', 1000);
  });
}

/**
 * Ручной W/L: ЖИВОЙ предпросмотр и сброс. [10.19.28]
 *
 * Было: ползунок менял только цифру рядом, картинка ждала «Применить» — врач
 * крутил вслепую. Кнопки возврата не было вовсе, ни для чисел, ни для
 * изображения. Слова владельца: «двигаю бегунок и ничего не происходит… нет
 * кнопки сбросить для возврата не только цифр, но и самого изображения».
 *
 * Стало: правка применяется НА ХОДУ, не чаще раза в кадр (правило и его
 * проверка — core/wlManual.js: последнее значение доходит всегда, иначе
 * картинка застывала бы на предпоследнем положении пальца). «Сброс»
 * возвращает окно, которое было ДО правки — то есть выбранный пресет, а не
 * абстрактные 400/40.
 *
 * Применяется ВО ВСЕ СРЕЗЫ (applyWindowToSlices) — по решению владельца и ради
 * единообразия: чипы-пресеты выше по панели делают ровно это, и ползунок,
 * бивший в одно окно, вёл себя иначе, чем соседи.
 *
 * Ползунков ДВЕ ПАРЫ: сайдбарная (custom-ww/custom-wc) и мобильная
 * (custom-ww-m/custom-wc-m, связана через data-sync). Чинятся как одна: иначе
 * на телефоне ползунок остался бы мёртвым — там та же панель, только в ящике.
 */
function bindCustomWL() {
  const пары = [
    { ww: $('custom-ww'), wc: $('custom-wc') },
    { ww: $('custom-ww-m'), wc: $('custom-wc-m') },
  ].filter((п) => п.ww && п.wc);
  if (!пары.length) return;

  // [11.1.17] Шкала — из максимумов каталога чипов, а не из чисел разметки:
  // зашитые max 8000/4000 не вмещали собственный чип PET 30000/15000, при
  // том что wlmanual_test прямо пиннит «у ПЭТ — тысячи» (аудит §2.1).
  const пределы = пределыШкалы();
  for (const п of пары) {
    п.ww.max = Math.max(Number(п.ww.max) || 0, пределы.wwMax);
    п.wc.max = Math.max(Number(п.wc.max) || 0, пределы.wcMax);
    п.wc.min = Math.min(Number(п.wc.min) || 0, пределы.wcMin);
  }

  const подписи = () => [$('custom-ww-val'), $('custom-wc-val')];
  const память = памятьОкна();

  const окноНаЭкране = () => {
    try {
      const re = getRenderingEngine?.();
      const vp = re?.getViewport?.(_ctx.getCurrentViewportId());
      const r = vp?.getProperties?.()?.voiRange;
      if (!r || !Number.isFinite(r.lower) || !Number.isFinite(r.upper)) return null;
      return зажать({ ww: r.upper - r.lower, wc: (r.upper + r.lower) / 2 });
    } catch (e) { return null; }
  };

  const показатьЧисла = (ww, wc) => {
    for (const п of пары) {
      // [11.1.17] Сначала растянуть шкалу, потом писать: иначе браузер молча
      // зажимает value к max, и подпись расходится с бегунком (аудит §2.1).
      подстроитьШкалу(п.ww, ww); подстроитьШкалу(п.wc, wc);
      if (String(п.ww.value) !== String(ww)) п.ww.value = ww;
      if (String(п.wc.value) !== String(wc)) п.wc.value = wc;
      for (const эл of [п.ww, п.wc]) {
        const рядом = эл.parentElement?.querySelector('.ctrl-value');
        if (рядом && !рядом.id) рядом.textContent = эл.value;
      }
    }
    const [вWW, вWC] = подписи();
    if (вWW) вWW.textContent = ww;
    if (вWC) вWC.textContent = wc;
  };

  const применить = ({ ww, wc }) => {
    applyWindowToSlices({ ww, wc });
    updateWLOverlay(ww, wc);
  };
  const огр = поКадрам(применить);

  const наДвижение = (п) => {
    const з = зажать({ ww: п.ww.value, wc: п.wc.value });
    if (!з.годно) return;
    // Точка возврата — то, что показано на экране ДО первого движения, а не
    // положение ползунка: ползунок мог остаться от прошлой серии.
    память.началПравку(окноНаЭкране() || з);
    показатьЧисла(з.ww, з.wc);
    огр.подать({ ww: з.ww, wc: з.wc });
    // Ползунок ведёт сам себя: чипы-пресеты больше не выглядят выбранными.
    $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => { c.classList.remove('active'); c.setAttribute('aria-pressed', 'false'); });
  };

  for (const п of пары) {
    п.ww.addEventListener('input', () => наДвижение(п), { signal: _ac.signal });
    п.wc.addEventListener('input', () => наДвижение(п), { signal: _ac.signal });
  }

  // «Применить» остаётся: она фиксирует явно и нужна тем, кто ждёт нажатия.
  on('btn-apply-custom-wl', 'click', () => {
    const з = зажать({ ww: пары[0].ww.value, wc: пары[0].wc.value });
    if (!з.годно) return;
    память.началПравку(з);
    применить(з);
    showToast(`Окно: W:${з.ww} L:${з.wc}`, 'success', 1200);
  });

  on('btn-reset-custom-wl', 'click', () => {
    const в = память.дляСброса();
    if (!в.есть) { showToast(в.причина, 'info', 2500); return; }
    огр.сброситьОжидание();
    применить(в.окно);
    показатьЧисла(в.окно.ww, в.окно.wc);
    память.сброшено();
    showToast(`Возврат к W:${в.окно.ww} L:${в.окно.wc}`, 'info', 1800);
  });

  // Окно, пришедшее ИЗВНЕ, становится новой точкой возврата — иначе «Сброс»
  // уводил бы к позапрошлому состоянию. Отдельного события смены окна в
  // программе нет (проверял), поэтому берём то, что ДЕЙСТВИТЕЛЬНО показано:
  // voiRange живого окна. Это надёжнее любого события — оно описывает картинку
  // на экране, а не намерение того, кто окно менял.
  // Чип-пресет и всё прочее, что меняет окно мимо ползунка: после их работы
  // запоминаем показанное как новую точку возврата.
  const подхватитьИзвне = () => {
    const з = окноНаЭкране();
    if (з?.годно) { память.запомнитьИзвне(з); показатьЧисла(з.ww, з.wc); }
  };
  document.addEventListener('click', (e) => {
    if (e.target?.closest?.('.preset-chip[data-ww], .preset-chip[data-wl-auto]')) {
      setTimeout(подхватитьИзвне, 0);   // после того, как пресет применён
    }
  }, { signal: _ac.signal });
}

// ============================================================
// RIGHT TABS
// ============================================================
function bindRightTabs() {
  onAll('.right-tab[data-tab]', 'click', (e) => {
    const tabId = e.currentTarget.dataset.tab;
    // [11.1.16] aria-selected раньше был мёртвым: разметка ставила true
    // «Пресетам» навсегда, обработчик переключал только классы — скринридер
    // объявлял выбранными «Пресеты», даже когда открыты «Отчёты». Теперь
    // атрибут ходит вместе с классом. (aria-expanded раскрывашки жив и был —
    // htmlInit.js; аудит 11.1.15 на его счёт ошибался.)
    $$('.right-tab').forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
    $$('.tab-panel').forEach(p => p.classList.remove('active'));
    e.currentTarget.classList.add('active');
    e.currentTarget.setAttribute('aria-selected', 'true');
    const panel = $(tabId);
    if (panel) panel.classList.add('active');
  });
}

// ============================================================
// PANEL COLLAPSES
// ============================================================
function bindPanelCollapses() {
  onAll('.panel-header[data-panel]', 'click', (e) => {
    const panelId = e.currentTarget.dataset.panel;
    const body = $(panelId);
    if (!body) return;
    body.classList.toggle('collapsed');
    const toggle = e.currentTarget.querySelector('.toggle');
    if (toggle) toggle.textContent = body.classList.contains('collapsed') ? '▸' : '▾';
  });
}

// ============================================================
// MODALS
// ============================================================
function bindModals() {
  // [FIX] Ловим ВСЕ элементы с data-close (не только .modal-close)
  onAll('[data-close]', 'click', (e) => closeModal(e.currentTarget.dataset.close));
  onAll('.modal-overlay', 'click', (e) => { if (e.target === e.currentTarget) e.target.classList.remove('open'); });
}

// [10.0.3] Модальные окна ведёт ModalManager: ловушка фокуса, Esc, клик по
// подложке, стопка открытых окон. Здесь было просто добавление и снятие
// класса — работало, но с клавиатуры окно было непроходимо: Tab уходил на
// страницу за окном, Esc не закрывал вовсе.
function openModal(id) { ModalManager.open(id); }
function closeModal(id) { ModalManager.close(id); }

// ============================================================
// SIDEBAR TOGGLES
// ============================================================
function bindSidebarToggles() {
  on('btn-sidebar-left-toggle', 'click', () => {
    const el = $('sidebar-left');
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });
  on('btn-sidebar-right-toggle', 'click', () => {
    const el = $('sidebar-right');
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });
}

// ============================================================
// ALL SLIDERS — auto-update value displays
// ============================================================
let _последнийVRTПресет = null;   // [11.1.23] что пере-применять при смене «Плотности тканей»

/** [11.1.24] «Вернуть тело» после изоляции органа пере-применяет этот пресет. */
export function получитьПоследнийVRTПресет() { return _последнийVRTПресет; }

function bindSliderUpdates() {
  const pairs = [
    ['brush-size', 'brush-size-val', null],
    ['seg-opacity', 'seg-opacity-val', v => v + '%'],
    ['nodule-thresh', 'nodule-thresh-val', v => (v / 100).toFixed(2)],
    // [11.0.2] ПОДКЛЮЧЕНЫ (решение владельца). Раньше оба меняли только
    // подпись рядом с собой, и «Объём 3D» был разделом из двух вывесок.
    ['vrt-opacity-scale', 'vrt-opacity-scale-val', v => v + '%'],   // [11.1.23]
    ['vrt-opacity-scale-m', 'vrt-opacity-scale-m-val', v => v + '%'],   // [11.1.26] мобильный двойник
    ['vrt-crop-level-m', 'vrt-crop-level-m-val', v => v + '%'],
    ['vrt-soft-scale', 'vrt-soft-scale-val', v => v + '%'],      // [11.1.47] мягкие ткани
    ['vrt-soft-thr', 'vrt-soft-thr-val', v => v + ' HU'],
    ['vrt-win-depth', 'vrt-win-depth-val', v => v + '%'],       // [11.1.46] окно обзора
    ['vrt-win-size', 'vrt-win-size-val', v => v + '%'],
    ['vrt-win-x', 'vrt-win-x-val', v => String(v)],
    ['vrt-win-z', 'vrt-win-z-val', v => String(v)],         // [11.1.35] «Убрать стол» на телефоне

    ['vol-iso', 'vol-iso-val', null],
    ['vol-opacity', 'vol-opacity-val', v => v + '%'],
    // [10.19.30] пара fusion-opacity убрана: ползунка нет в разметке с тех же
    // времён, что и его кнопок-призраков (см. featureBindings). Живой ползунок
    // прозрачности — ds-fusion-opacity, его ведёт proFeaturesBindings.
    ['cine-fps-tab', 'cine-fps-tab-val', null],
    ['cine-fps', 'cine-fps-val', null],
    ['mc-iso', 'mc-iso-val', null],
    ['thresh-low', 'thresh-low-val', null],
    ['thresh-high', 'thresh-high-val', null],
    ['ann-line-width', 'ann-line-width-val', null],
    ['ann-font-size', 'ann-font-size-val', null],
    ['endo-position', 'endo-pos-val', v => v + '%'],
    ['endo-fov', 'endo-fov-val', v => v + '°'],
    // [11.0.2] пара slab-thickness убрана вместе с разделом «Слэб / Толщина»:
    // ползунка нет в разметке, а подпись была всей его работой.
    // [10.19.11] Три ползунка наклона (oblique-x/y/z) убраны ОТСЮДА намеренно.
    // Здесь они только обновляли подпись — камера не поворачивалась, то есть
    // косых реформатов не было вовсе. Теперь их ведёт ui/obliqueBindings.js:
    // он и подпись меняет, и ориентацию окна применяет.
    ['dsa-gain', 'dsa-gain-val', v => parseFloat(v).toFixed(1)],
    ['clip-x', 'clip-x-val', v => v + '%'],
    ['clip-y', 'clip-y-val', v => v + '%'],
    ['clip-z', 'clip-z-val', v => v + '%'],
    ['region-grow-range', 'region-grow-range-val', v => '±' + v],
  ];
  pairs.forEach(([sliderId, valId, fmt]) => {
    const slider = $(sliderId), val = $(valId);
    if (slider && val) slider.addEventListener('input', () => { val.textContent = fmt ? fmt(slider.value) : slider.value; }, { signal: _ac.signal });
  });
  // Color picker
  // [11.1.21] Провод от «Стиля аннотаций» к движку — раздел был вывеской
  // (аудит §1.3): цвет красил подпись, линии оставались зелёными. Цвет
  // применяется живо, толщина и шрифт — по отпусканию; при недоступном
  // движке говорим один раз, а не молчим.
  let _стильПредупредил = false;
  const _применитьСтиль = (н) => {
    if (setAnnotationStyle(н)) return;
    if (!_стильПредупредил) {
      _стильПредупредил = true;
      showToast('Стиль аннотаций применится после загрузки исследования', 'info', 2500);
    }
  };
  // [11.1.23] «Плотность тканей»: масштаб задаётся движку пресетов, затем
  // активный пресет применяется заново — иначе новая кривая легла бы только
  // при следующем ручном выборе. По отпусканию, не живьём: каждое применение
  // пересобирает передаточные функции объёма.
  // [11.1.25] «Плотность тканей» действует СРАЗУ (замечание владельца:
  // «почему реагирует только на следующий пресет?»). Причина была в том,
  // что пере-применить пресет мог лишь тот, кто помнил ВЫБОР ВРАЧА, — а
  // пресет часто ставится при загрузке, профилем или из другой панели, и
  // тогда помнить было нечего. Теперь движок пресетов сам держит последнюю
  // кривую и пересчитывает её на живом объёме; нам остаётся перерисовать.
  // Слушаем 'input' (тянем ползунок — картинка меняется), перерисовку
  // прижимаем к кадру, чтобы не звать рендер на каждый пиксель движения.
  let _плотностьЖдёт = false;
  // [11.1.36] Мобильный двойник подключён НАПРЯМУЮ к тому же хозяину, а не
  // через цепочку data-sync-input → синтетическое событие → делегирование на
  // document (mobileBindings). Та цепочка ни разу не жила на настоящем
  // телефоне (двойник до 11.1.35 был недостижим), и владелец получил
  // «движется, но ничего не делает». Двойник зеркалит значение в настоящий
  // ползунок и будит его событием — хозяин один, путь короткий и видимый.
  on('vrt-opacity-scale-m', 'input', (e) => {
    const наст = $('vrt-opacity-scale');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('input', { bubbles: false }));
  });
  on('vrt-opacity-scale-m', 'change', (e) => {
    const наст = $('vrt-opacity-scale');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('change', { bubbles: false }));
  });
  // [11.1.47] Мягкие ткани отдельно от органов. Хозяин один — этот блок.
  let _мягкиеЖдут = false;
  const _мягкие = () => {
    const коэф = (Number($('vrt-soft-scale')?.value) || 100) / 100;
    const порог = Number($('vrt-soft-thr')?.value) || 70;
    // [11.1.47] Импорт СТАТИЧЕСКИЙ, как у setGlobalOpacityScale строкой 33.
    try {
      const легло = setSoftTissueScale(коэф, порог);
      if (!легло) {
        if (коэф < 1) showToast('Гасить нечего: объёмная картинка ещё не построена', 'info', 2500);
        return;
      }
      // [11.1.47.1] ПЕРЕРИСОВКА — вот чего не хватало. Владелец: «ползунки
      // совсем не реагируют, даже в крайних положениях». И были правы:
      // setSoftTissueScale честно менял функцию непрозрачности, но НИКТО не
      // просил окна перерисоваться — экран показывал прежний кадр до
      // следующего касания мыши. У соседней «Плотности тканей» перерисовка
      // стоит сразу за расчётом (строки выше), а я её не повторил. Тот же
      // приём: один кадр на requestAnimationFrame, чтобы не рвать таскание.
      if (_мягкиеЖдут) return;
      _мягкиеЖдут = true;
      requestAnimationFrame(() => {
        _мягкиеЖдут = false;
        try {
          const re = getRenderingEngine();
          re?.renderViewports?.(re.getViewports().map((v) => v.id));
        } catch (err) { log.debug('[Мягкие ткани] перерисовка:', err.message); }
      });
    } catch (e) { showToast('Мягкие ткани: ' + e.message, 'warning', 3000); }
  };
  // По отпусканию — словами, как у «Плотности тканей».
  const _мягкиеСловами = () => {
    const проценты = Number($('vrt-soft-scale')?.value) || 100;
    const порог = Number($('vrt-soft-thr')?.value) || 70;
    showToast(проценты >= 100
      ? 'Мягкие ткани: без гашения (100%)'
      : `Мягкие ткани: ${проценты}% ниже ${порог} HU — органы и сосуды не тронуты`,
      'info', 1600);
  };
  on('vrt-soft-scale', 'input', _мягкие);
  on('vrt-soft-thr', 'input', _мягкие);
  on('vrt-soft-scale', 'change', _мягкиеСловами);
  on('vrt-soft-thr', 'change', _мягкиеСловами);

  on('vrt-opacity-scale', 'input', (e) => {
    const проценты = Number(e.target.value) || 100;
    const легло = setGlobalOpacityScale(проценты / 100);
    if (!легло) return;   // объёма ещё нет — ляжет с ближайшим пресетом
    if (_плотностьЖдёт) return;
    _плотностьЖдёт = true;
    requestAnimationFrame(() => {
      _плотностьЖдёт = false;
      try {
        const re = getRenderingEngine();
        re?.renderViewports?.(re.getViewports().map((v) => v.id));
      } catch (err) { log.debug('[Плотность тканей] перерисовка:', err.message); }
    });
  });
  // По отпусканию — словами: подтверждение или честное «ещё нет объёма».
  on('vrt-opacity-scale', 'change', (e) => {
    const проценты = Number(e.target.value) || 100;
    const легло = setGlobalOpacityScale(проценты / 100);
    showToast(легло
      ? `Плотность тканей: ${проценты}%`
      : `Плотность тканей: ${проценты}% — применится, как только появится объёмная картинка`,
      'info', легло ? 1200 : 2600);
  });

  // ══ [11.1.26] «УБРАТЬ СТОЛ» ══
  // Дека — те же 100–700 HU, что кость: пресетом не отделить, отделяем
  // геометрией. Плоскость отсечения режет ПОКАЗ, не данные; выключатель и
  // ползунок возвращают всё как было.
  /**
   * [11.1.34] Ищем объёмного актёра ЦЕПКО и по стадиям, чтобы отказ называл
   * настоящую причину. Прошлая редакция сдавалась на первом же null и
   * говорила «нет объёмного окна» даже тогда, когда окно есть, а объём в
   * него ещё не подан, — и переключатель при этом не двигался вовсе
   * (замечание владельца: «не перемещается вправо»).
   * @returns {{стадия:'нет-окна'|'окно-пустое'|'нет-маппера'|'готово', vp?, актёр?, mapper?}}
   */
  /**
   * [11.1.36] Собираем ВСЕ объёмные окна, а не первое попавшееся. Первое
   * попавшееся и было ямой: плоскость ложилась в окно режима «3D», а
   * «3D пресет» — это ДРУГОЕ окно (шестое, MPR6, во весь экран), и в нём
   * стол оставался при сдвинутом тумблере (замечание владельца, скриншоты).
   * Возвращает список готовых {vp, mapper, актёр} и сводную стадию отказа.
   */
  const _актёрыОбъёма = () => {
    const готовые = [];
    const стадии = new Set();
    try {
      const re = getRenderingEngine();
      const окна = re?.getViewports?.() || [];
      for (const vp of окна) {
        const т = String(vp?.type || '').toLowerCase();
        const объёмное = т.includes('volume3d') || т === 'volume_3d' || т.includes('3d')
          || String(vp?.id || '').toLowerCase().includes('3d');
        if (!объёмное) continue;
        // Актёр достаётся двумя путями: getDefaultActor есть не во всех
        // сборках Cornerstone (оговорка уже записана в viewport.js 6.7.33).
        const актёр = vp.getDefaultActor?.()?.actor
          || vp.getActors?.()?.[0]?.actor
          || vp.getActors?.()?.[0]?.volumeActor
          || null;
        if (!актёр) { стадии.add('окно-пустое'); continue; }
        const mapper = актёр.getMapper?.() || null;
        if (!маперПоддерживает(mapper)) { стадии.add('нет-маппера'); continue; }
        готовые.push({ vp, актёр, mapper });
      }
    } catch (e) {
      log.debug('[Убрать стол] поиск актёров:', e.message);
    }
    const стадия = готовые.length ? 'готово'
      : (стадии.has('окно-пустое') ? 'окно-пустое'
        : (стадии.has('нет-маппера') ? 'нет-маппера' : 'нет-окна'));
    return { стадия, готовые };
  };

  const _причина = (стадия) => ({
    'нет-окна': 'Нет объёмного окна: включите раскладку с 3D (например, MPR+3D)',
    'окно-пустое': 'Объёмное окно есть, но объём в него ещё не подан — дождитесь загрузки и повторите',
    'нет-маппера': 'Этот режим рендера не поддерживает плоскости отсечения (кинематический — не поддерживает; переключитесь на обычный объём)',
  })[стадия] || 'Не удалось отсечь стол';

  const _применитьОтсечение = async (включено) => {
    const о = _актёрыОбъёма();
    if (о.стадия !== 'готово') return { ок: false, стадия: о.стадия, причина: _причина(о.стадия) };
    try {
      const доля = (Number($('vrt-crop-level')?.value) || 12) / 100;
      const vtkPlane = включено ? await getVtkPlaneClass() : null;
      if (включено && !vtkPlane?.newInstance) {
        return { ок: false, стадия: 'нет-маппера', причина: 'Плоскости отсечения недоступны в этой сборке' };
      }
      let легло = 0;
      const имена = [];
      for (const { vp, актёр, mapper } of о.готовые) {
        try {
          mapper.removeAllClippingPlanes();
          if (включено) {
            // [11.1.46] Плоскостей может быть НЕСКОЛЬКО: одна для среза
            // (спина или перед) плюс шесть для окна обзора. Маппер их
            // пересекает — это и даёт коробку.
            const b = актёр.getBounds?.() || [];
            const список = [];
            const окноВкл = $('vrt-window-box')?.classList.contains('on');
            // [11.1.49] ШЕСТЬ — ПРЕДЕЛ, И ОН ЖЁСТКИЙ. Шейдер объёмного маппера
            // vtk.js держит РОВНО шесть плоскостей отсечения (сверено с
            // Rendering/OpenGL/VolumeMapper.js: vClipPlaneNormals[6]). Мы же
            // при включённом окне слали семь — срез плюс шесть граней
            // коробки, — и рендер срывался в пустоту: у владельца исчезали
            // оба объёмных окна целиком.
            //
            // Поэтому при включённом окне срез НЕ добавляется: передняя
            // грань коробки и так режет спереди, а «Убрать стол» заменяется
            // задней гранью. Ровно шесть.
            if (!окноВкл) {
              const сторона = $('vrt-crop-side')?.value === 'спереди' ? 'спереди' : 'сзади';
              const пл = плоскостьСоСтороны(b, доля, 1, сторона);
              if (пл) список.push(пл);
            }
            if (окноВкл) {
              const окно = плоскостиОкнаОбзора(b, {
                глубина: (Number($('vrt-win-depth')?.value) || 50) / 100,
                размер: (Number($('vrt-win-size')?.value) || 50) / 100,
                сдвигX: (Number($('vrt-win-x')?.value) || 0) / 100,
                сдвигZ: (Number($('vrt-win-z')?.value) || 0) / 100,
              });
              if (окно) список.push(...окно);
            }
            if (!список.length) continue;   // границы этого окна не читаются
            if (список.length > 6) {
              // Страховка на будущее: лучше показать шесть, чем пустой экран.
              log.warn(`[Отсечение] плоскостей ${список.length}, шейдер держит 6 — лишние отброшены`);
              список.length = 6;
            }
            for (const п of список) mapper.addClippingPlane(vtkPlane.newInstance({ origin: п.origin, normal: п.normal }));
          }
          vp.render?.();
          легло++; имена.push(vp.id);
        } catch (eо) { log.debug(`[Убрать стол] окно ${vp?.id}:`, eо.message); }
      }
      if (включено && !легло) {
        return { ок: false, стадия: 'окно-пустое', причина: 'Границы объёма не читаются — попробуйте после полной загрузки' };
      }
      log.info(`[Убрать стол] ${включено ? 'отсечение' : 'возврат'} в окнах: ${легло} (${имена.join(', ')})`);
      return { ок: true };
    } catch (e) {
      log.warn('[Убрать стол]', e.message);
      return { ок: false, стадия: 'нет-окна', причина: 'Ошибка отсечения: ' + e.message };
    }
  };

  // [11.1.34] Переключатель двигается СРАЗУ, а при неудаче возвращается
  // назад с объяснением. Прежний порядок (сперва применить, потом двигать)
  // выглядел как мёртвая кнопка: врач жмёт — ничего не происходит.
  const _показатьСостояние = (кнопка, вкл) => {
    кнопка.classList.toggle('on', вкл);
    кнопка.setAttribute('aria-checked', String(вкл));
    const ряд = $('vrt-crop-row');
    if (ряд) ряд.style.display = вкл ? '' : 'none';
    const рядС = $('vrt-crop-side-row');           // [11.1.46] выбор стороны
    if (рядС) рядС.style.display = вкл ? '' : 'none';
    // [11.1.35] Мобильный двойник — немое зеркало: состояние ему показывает
    // ТОЛЬКО этот хозяин, свой логики у двойника нет (data-proxy кликает сюда).
    const дв = $('vrt-crop-table-m');
    if (дв) { дв.classList.toggle('on', вкл); дв.setAttribute('aria-checked', String(вкл)); }
    const рядМ = $('vrt-crop-row-m');
    if (рядМ) рядМ.style.display = вкл ? '' : 'none';
  };
  // [11.1.35] Метка «у тумблера есть хозяин»: общий перещёлкиватель
  // bindToggles обходит помеченные стороной — иначе он сбрасывал класс
  // обратно сразу после этого обработчика (см. надгробие в bindToggles).
  if ($('vrt-crop-table')) $('vrt-crop-table').dataset.хозяин = 'sidebarBindings/УбратьСтол';
  if ($('vrt-crop-table-m')) $('vrt-crop-table-m').dataset.хозяин = 'sidebarBindings/УбратьСтол(зеркало)';
  on('vrt-crop-table', 'click', async (e) => {
    const кнопка = e.currentTarget;
    const вкл = !кнопка.classList.contains('on');
    _показатьСостояние(кнопка, вкл);           // сразу: кнопка живая
    const р = await _применитьОтсечение(вкл);
    if (!р.ок) {
      _показатьСостояние(кнопка, !вкл);        // не вышло — честно вернуть
      showToast(р.причина, 'warning', 4500);
      return;
    }
    showToast(вкл ? 'Стол отсечён со стороны спины — ползунком подберите уровень' : 'Стол возвращён', 'info', 2000);
  });
  on('vrt-crop-level', 'input', () => {
    if ($('vrt-crop-table')?.classList.contains('on')) _применитьОтсечение(true);
  });
  // [11.1.46] Сторона среза и ОКНО ОБЗОРА — тот же хозяин, тот же путь
  // применения: у отсечения один владелец (доктрина проекта).
  on('vrt-crop-side', 'change', () => {
    if ($('vrt-crop-table')?.classList.contains('on')) _применитьОтсечение(true);
  });
  const _окноВкл = () => $('vrt-window-box')?.classList.contains('on');
  const _применитьОкно = async () => {
    const ряды = $('vrt-window-rows');
    if (ряды) ряды.style.display = _окноВкл() ? '' : 'none';
    // Окно живёт поверх среза: если тумблер стола выключен, включаем сам
    // расчёт с нулевым срезом, иначе плоскостям некуда лечь.
    const р = await _применитьОтсечение(_окноВкл() || $('vrt-crop-table')?.classList.contains('on'));
    if (!р.ок) showToast(р.причина, 'warning', 4500);
  };
  if ($('vrt-window-box')) $('vrt-window-box').dataset.хозяин = 'sidebarBindings/ОкноОбзора';
  on('vrt-window-box', 'click', async (e) => {
    const вкл = !e.currentTarget.classList.contains('on');
    e.currentTarget.classList.toggle('on', вкл);
    e.currentTarget.setAttribute('aria-checked', String(вкл));
    await _применитьОкно();
    if (вкл) showToast('Окно обзора: видно только содержимое коробки. Пока оно включено, срез «Убрать стол» не применяется — шейдер держит ровно 6 плоскостей, а у коробки их 6.', 'info', 6000);
  });
  for (const п of ['vrt-win-depth', 'vrt-win-size', 'vrt-win-x', 'vrt-win-z']) {
    on(п, 'input', () => { if (_окноВкл()) _применитьОтсечение(true); });
  }
  // [11.1.36] Мобильный ползунок уровня — напрямую к хозяину (см. надгробие
  // у «Плотности тканей» выше: цепочка data-sync-input не жила на телефоне).
  on('vrt-crop-level-m', 'input', (e) => {
    const наст = $('vrt-crop-level');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('input', { bubbles: false }));
  });

  // [11.1.36] ПЕРЕПРИМЕНЕНИЕ ОТСЕЧЕНИЯ. Плоскость живёт НА МАППЕРЕ АКТЁРА,
  // а актёры пересобираются: повторная загрузка исследования («переподключаюсь»
  // — замечание владельца: тумблер вправо, процент на месте, а стол ВЕРНУЛСЯ),
  // смена раскладки, применение пресета. Тумблер оставался на экране правдой
  // о ЖЕЛАНИИ врача, но никто не переносил плоскость на новый актёр. Теперь
  // хозяин слушает шину и, если тумблер включён, кладёт плоскость заново —
  // с повторами, пока объём подаётся в окна; если ни одно окно не примет
  // плоскости совсем (кинематический режим), тумблер честно выключается и
  // причина говорится вслух один раз.
  let _переприменениеИдёт = false;
  const _переприменитьОтсечение = async (попыток = 8) => {
    const кнопка = $('vrt-crop-table');
    if (!кнопка?.classList.contains('on')) return;
    if (_переприменениеИдёт) return;
    _переприменениеИдёт = true;
    try {
      for (let i = 0; i < попыток; i++) {
        const р = await _применитьОтсечение(true);
        if (р.ок) return;
        if (р.стадия === 'нет-маппера') {
          _показатьСостояние(кнопка, false);
          showToast('«Убрать стол» выключен: ' + р.причина, 'warning', 5000);
          return;
        }
        // окно-пустое / нет-окна — объём ещё едет; подождать и повторить
        await new Promise((r) => setTimeout(r, 400));
      }
      log.info('[Убрать стол] переприменение: окна так и не приняли объём — оставляю до следующего события');
    } finally { _переприменениеИдёт = false; }
  };
  busOn(BUS.VOLUME_LOAD_DONE, () => _переприменитьОтсечение());
  busOn(BUS.LAYOUT_CHANGED, () => _переприменитьОтсечение());
  busOn(BUS.PRESET_CHANGED, () => _переприменитьОтсечение());

  // ══ [11.1.26] ПРОФИЛИ УЧРЕЖДЕНИЙ в настройках бланка ══
  const _наполнитьПрофили = (выбрать = '') => {
    const сел = $('blank-profile-pick');
    if (!сел) return;
    const п = прочитатьПрофили();
    сел.innerHTML = '<option value="">— профиль учреждения —</option>'
      + п.map((x) => `<option value="${x.имя.replace(/"/g, '&quot;')}"${x.имя === выбрать ? ' selected' : ''}>${x.имя}</option>`).join('');
  };
  // [11.1.30] Списки шрифтов наполняются из каталога reportBlank — в
  // разметке их нет намеренно: два списка (шапка/тело) разошлись бы, как
  // когда-то гриды чипов W/L (11.1.17).
  const _наполнитьШрифты = () => {
    for (const id of ['blank-font-head', 'blank-font-body']) {
      const сел = $(id);
      if (сел && !сел.options.length) сел.innerHTML = ШРИФТЫ.map((ш) => `<option value="${ш}">${ш}</option>`).join('');
    }
  };
  /**
   * [11.1.31] ЕДИНСТВЕННЫЙ заполнитель модалки бланка. Хозяев было ДВА:
   * featureBindings.показатьНастройкиБланка (старый, знал только четыре
   * поля) и этот. Открывал модалку первый — поэтому шрифты, ширина и место
   * логотипа на экране оставались пустыми, хотя в коде были (замечание
   * владельца со скриншотом). Порода известная: «один хозяин у контрола».
   */
  const _вФорму = (б) => {
    if ($('blank-org')) $('blank-org').value = б.учреждение || '';
    if ($('blank-req')) $('blank-req').value = б.реквизиты || '';
    if ($('blank-depts')) $('blank-depts').value = Object.entries(б.отделения || {}).map(([к, з]) => `${к} = ${з}`).join('\n');
    if ($('blank-docs')) $('blank-docs').value = (б.врачи || []).map((в) => `${в.фио} = ${в.должность || ''}`).join('\n');
    const прев = $('blank-logo-prev');
    if (прев) { прев.src = б.логотип || ''; прев.style.display = б.логотип ? '' : 'none'; }
    // [11.1.30] Вид логотипа, шрифты, автооткрытие
    _наполнитьШрифты();
    const л = логотипБланка(б); const ш = шрифтыБланка(б);
    if ($('blank-logo-width')) { $('blank-logo-width').value = л.ширинаМм; }
    if ($('blank-logo-width-val')) $('blank-logo-width-val').textContent = л.ширинаМм + ' мм';
    if ($('blank-logo-place')) $('blank-logo-place').value = л.место;
    if ($('blank-font-head')) $('blank-font-head').value = ш.шапкаИмя;
    if ($('blank-font-head-size')) $('blank-font-head-size').value = ш.шапкаПт;
    if ($('blank-font-body')) $('blank-font-body').value = ш.телоИмя;
    if ($('blank-font-body-size')) $('blank-font-body-size').value = ш.телоПт;
    if ($('blank-open-after-save')) $('blank-open-after-save').checked = б.открыватьПослеСохранения !== false;
    // [11.1.35] Поля листа (просьба владельца: 1,5 см по умолчанию + настройка)
    const пл = поляБланка(б);
    if ($('blank-margin-top')) $('blank-margin-top').value = пл.верхМм;
    if ($('blank-margin-bottom')) $('blank-margin-bottom').value = пл.низМм;
    if ($('blank-margin-left')) $('blank-margin-left').value = пл.левоМм;
    if ($('blank-margin-right')) $('blank-margin-right').value = пл.правоМм;
    // Галочки разделов формы — из профиля (пусто = все включены)
    document.querySelectorAll('#report-sections input[data-section]').forEach((г) => {
      const карта = б.разделы || {};
      г.checked = !Object.keys(карта).length || карта[г.dataset.section] !== false;
    });
  };
  // Модалку открывает featureBindings, а наполняет — этот заполнитель.
  window.__mikhmelЗаполнитьБланк = () => _вФорму(прочитатьБланк());

  on('blank-logo-width', 'input', (e) => {
    const п = $('blank-logo-width-val'); if (п) п.textContent = e.target.value + ' мм';
  });
  const _изФормы = () => ({
    // [11.1.30] Вид логотипа, шрифты, автооткрытие и набор разделов едут
    // ВМЕСТЕ с учреждением: это части одного бланка, и в файл профиля они
    // должны попадать одним куском — иначе перенос на другой компьютер
    // привезёт шапку без её же оформления.
    логотипВид: {
      ширинаМм: Number($('blank-logo-width')?.value) || 22,
      место: $('blank-logo-place')?.value || 'слева',
    },
    шрифты: {
      шапкаИмя: $('blank-font-head')?.value || 'Times New Roman',
      шапкаПт: Number($('blank-font-head-size')?.value) || 12,
      телоИмя: $('blank-font-body')?.value || 'Times New Roman',
      телоПт: Number($('blank-font-body-size')?.value) || 12,
    },
    открыватьПослеСохранения: $('blank-open-after-save') ? !!$('blank-open-after-save').checked : true,
    разделы: Object.fromEntries([...document.querySelectorAll('#report-sections input[data-section]')]
      .map((г) => [г.dataset.section, !!г.checked])),
    учреждение: $('blank-org')?.value || '',
    реквизиты: $('blank-req')?.value || '',
    логотип: $('blank-logo-prev')?.src?.startsWith('data:') ? $('blank-logo-prev').src : '',
    отделения: Object.fromEntries(($('blank-depts')?.value || '').split('\n').map((с) => с.split('=')).filter((ч) => ч.length >= 2 && ч[0].trim()).map((ч) => [ч[0].trim().toUpperCase(), ч.slice(1).join('=').trim()])),
    врачи: ($('blank-docs')?.value || '').split('\n').map((с) => с.split('=')).filter((ч) => ч.length >= 2 && ч[0].trim()).map((ч) => ({ фио: ч[0].trim(), должность: ч.slice(1).join('=').trim() })),
  });
  on('blank-profile-pick', 'change', (e) => {
    const п = прочитатьПрофили().find((x) => x.имя === e.target.value);
    if (!п) return;
    _вФорму(п.бланк);
    showToast(`Профиль «${п.имя}» подставлен — нажмите «Сохранить», чтобы применить к отчётам`, 'info', 3000);
  });
  on('btn-blank-profile-save', 'click', async () => {
    const { спроситьТекст } = await import('../utils/helpers.js');
    const имя = await спроситьТекст('Название профиля учреждения:', { поУмолчанию: ($('blank-org')?.value || '').split('\n').find((с) => с.trim()) || '' });
    if (!имя) return;
    const р = сохранитьПрофиль(имя, _изФормы());
    if (!р.ок) { showToast(р.причина, 'error', 3000); return; }
    _наполнитьПрофили(имя.trim());
    showToast(`Профиль «${имя.trim()}» сохранён (всего ${р.всего})`, 'success', 2500);
  });
  on('btn-blank-profile-del', 'click', () => {
    const имя = $('blank-profile-pick')?.value;
    if (!имя) { showToast('Сначала выберите профиль в списке', 'info', 2000); return; }
    if (!confirm(`Удалить профиль «${имя}»? Поля формы останутся как есть.`)) return;
    удалитьПрофиль(имя);
    _наполнитьПрофили();
    showToast('Профиль удалён', 'info', 1800);
  });
  on('btn-blank-profile-export', 'click', async () => {
    const { downloadBlob } = await import('../utils/helpers.js');
    const профили = прочитатьПрофили();
    if (!профили.length) { showToast('Профилей ещё нет — сперва «Сохранить как…»', 'info', 2500); return; }
    downloadBlob(new Blob([собратьФайлПрофилей(профили)], { type: 'application/json' }), `бланки_учреждений_${new Date().toISOString().slice(0, 10)}.json`);
    showToast(`Выгружено профилей: ${профили.length}`, 'success', 2500);
  });
  on('btn-blank-profile-import', 'click', () => $('blank-profile-file')?.click());
  on('blank-profile-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const р = разобратьФайлПрофилей(await файл.text());
    e.target.value = '';
    if (!р.ок) { showToast(р.причина, 'error', 4000); return; }
    // Слияние, а не замена: чужой файл не должен стирать свои бланки.
    const было = прочитатьПрофили();
    const слито = [...было.filter((с) => !р.профили.some((н) => н.имя === с.имя)), ...р.профили]
      .sort((a, b) => a.имя.localeCompare(b.имя, 'ru'));
    записатьПрофили(слито);
    _наполнитьПрофили(р.профили[0]?.имя || '');
    if (р.профили.length === 1) _вФорму(р.профили[0].бланк);
    showToast(`Загружено профилей: ${р.профили.length}. Выберите нужный и нажмите «Сохранить»`, 'success', 4000);
  });
  _наполнитьПрофили();

  // ══ [11.1.31] СПРАВОЧНИКИ БЛАНКА: контраст, аппараты, даты ══
  const _наполнитьСправочники = () => {
    const мод = (() => { try { return (_ctx?.getAllSeries?.() || [])[0]?.modality || ''; } catch (e) { return ''; } })();
    const кон = $('list-contrasts');
    if (кон) кон.innerHTML = контрастыДляМодальности(мод).map((к) => `<option value="${к.replace(/"/g, '&quot;')}">`).join('');
    const апп = $('list-devices');
    if (апп) апп.innerHTML = аппаратыДляМодальности(мод).map((а) => `<option value="${а.replace(/"/g, '&quot;')}">`).join('');
  };
  _наполнитьСправочники();
  // Открыли вкладку «Отчёты» — пересобрать под модальность текущего снимка:
  // на МР первым делом нужен гадолиний, на КТ — йод.
  document.querySelector('.right-tab[data-tab="tab-report"]')
    ?.addEventListener('click', () => setTimeout(_наполнитьСправочники, 80), { signal: _getSignal() });

  // Даты: точки расставляются на лету, ошибка называется словами и краснит поле.
  for (const id of ['report-birth', 'report-studydate']) {
    const поле = $(id);
    if (!поле) continue;
    поле.addEventListener('input', (e) => {
      const было = e.target.value;
      const стало = маскаДаты(было);
      if (стало !== было) e.target.value = стало;
      e.target.style.borderColor = '';
      e.target.title = '';
    }, { signal: _getSignal() });
    поле.addEventListener('blur', (e) => {
      const р = проверитьДату(e.target.value);
      e.target.style.borderColor = р.ок ? '' : '#ef4444';
      e.target.title = р.ок ? '' : р.причина;
      if (!р.ок) showToast(`${id === 'report-birth' ? 'Дата рождения' : 'Дата исследования'}: ${р.причина}`, 'warning', 3000);
    }, { signal: _getSignal() });
  }

  on('ann-color', 'input', (e) => {
    const v = $('ann-color-val'); if (v) v.textContent = e.target.value;
    _применитьСтиль({ color: e.target.value });
  });
  on('ann-line-width', 'change', (e) => _применитьСтиль({ lineWidth: e.target.value }));
  on('ann-font-size', 'change', (e) => _применитьСтиль({ fontSize: e.target.value }));
  // ── Clipping sliders → реальное отсечение объёма ──
  const clipX = $('clip-x'), clipY = $('clip-y'), clipZ = $('clip-z');
  if (clipX) clipX.addEventListener('input', () => setVolumeClipping(clipX.value, null, null), { signal: _ac.signal });
  if (clipY) clipY.addEventListener('input', () => setVolumeClipping(null, clipY.value, null), { signal: _ac.signal });
  if (clipZ) clipZ.addEventListener('input', () => setVolumeClipping(null, null, clipZ.value), { signal: _ac.signal });

  _подключитьОбъём3D();
}

/**
 * «Объём 3D»: порог ISO и общая прозрачность — теперь настоящие. [11.0.2]
 *
 * ЧТО БЫЛО. Оба ползунка меняли цифру рядом с собой и больше ничего: имена
 * `vol-iso` и `vol-opacity` встречались в проекте дважды — здесь и в таблице
 * подписей appInit. Раздел «Объём 3D» состоял из двух вывесок.
 *
 * ЧТО ДЕЛАЮТ. Правят кривую прозрачности объёмного актёра — тем же способом,
 * каким её правят МР-переносы (viewport.js:625) и редактор передаточной
 * функции этажом выше в этом же файле. Кривая строится в две точки: ниже
 * порога ISO объём прозрачен, выше — виден с заданной прозрачностью. Это
 * честный порог, а не «изоповерхность» в смысле марширующих кубов: для
 * поверхности есть отдельная кнопка «Построить поверхность» на вкладке
 * вычислений.
 *
 * КОНФЛИКТ С ПРЕСЕТАМИ — И ЧТО С НИМ СДЕЛАНО. Ту же кривую задают VRT-пресеты
 * левого сайдбара и редактор передаточной функции. Молча стирать чужую работу
 * нельзя в обе стороны, поэтому:
 *   • ползунок правит кривую только когда его двигают — не при загрузке, не
 *     при смене серии, не сам по себе;
 *   • ПРИМЕНЁННЫЙ ПРЕСЕТ ГЛАВНЕЕ: после `set3DPreset`/`applyRenderPreset`
 *     ползунки встают в положение, соответствующее новой кривой (см.
 *     `_снятьСКривой`), а не остаются показывать своё старое число. Иначе
 *     подпись врала бы о том, что на экране.
 * То есть последнее слово всегда за тем, к чему прикоснулись последним, и
 * подпись это слово повторяет.
 */
function _подключитьОбъём3D() {
  const iso = $('vol-iso'), прозр = $('vol-opacity');
  if (!iso && !прозр) return;

  /** Свойство объёмного актёра активного 3D-окна. */
  const свойство = () => {
    const re = getRenderingEngine();
    if (!re) return null;
    const id = find3DViewportId();
    if (!id) return null;
    const vp = re.getViewport(id);
    const запись = vp?.getDefaultActor?.() || vp?.getActors?.()?.[0];
    const prop = запись?.actor?.getProperty?.();
    return prop ? { vp, prop } : null;
  };

  const применить = () => {
    const о = свойство();
    if (!о) {
      showToast('Объёма нет: откройте исследование и включите режим 3D', 'warning', 3500);
      return false;
    }
    const порог = Number(iso?.value ?? 300);
    const альфа = Math.max(0, Math.min(1, Number(прозр?.value ?? 80) / 100));
    try {
      const кривая = о.prop.getScalarOpacity?.(0);
      if (!кривая?.removeAllPoints) { showToast('Это окно не даёт править прозрачность объёма', 'warning', 3000); return false; }
      кривая.removeAllPoints();
      // Узкая ступень перед порогом (1 % диапазона, но не меньше 1 HU): резкая
      // граница даёт «лесенку» на срезах, слишком мягкая — туман вместо формы.
      const ступень = Math.max(1, Math.abs(порог) * 0.01);
      кривая.addPoint(порог - ступень, 0);
      кривая.addPoint(порог, альфа);
      кривая.addPoint(3071, альфа);
      о.vp.render?.();
      _crCache?.forceRender?.();
      return true;
    } catch (e) {
      log.warn('[Объём 3D]', e.message);
      showToast('Не удалось изменить объём: ' + e.message, 'error', 3500);
      return false;
    }
  };

  if (iso) iso.addEventListener('change', применить, { signal: _ac.signal });
  if (прозр) прозр.addEventListener('change', применить, { signal: _ac.signal });

  /**
   * Подтянуть ползунки под кривую, которую поставил кто-то другой.
   * Зовётся после применения пресета: см. оговорку о конфликте выше.
   */
  window.__волОбъёмСнятьСКривой = () => {
    const о = свойство();
    if (!о) return;
    try {
      const кривая = о.prop.getScalarOpacity?.(0);
      const n = кривая?.getSize?.() ?? 0;
      if (!n) return;
      // Порог — первая точка, где прозрачность перестаёт быть нулевой;
      // альфа — наибольшее значение кривой.
      let порог = null, максАльфа = 0;
      const буфер = [0, 0, 0, 0];
      for (let i = 0; i < n; i++) {
        кривая.getNodeValue(i, буфер);
        const [x, y] = буфер;
        if (y > максАльфа) максАльфа = y;
        if (порог === null && y > 0.01) порог = x;
      }
      if (порог !== null && iso) { iso.value = String(Math.round(порог)); const v = $('vol-iso-val'); if (v) v.textContent = iso.value; }
      if (максАльфа > 0 && прозр) { прозр.value = String(Math.round(максАльфа * 100)); const v = $('vol-opacity-val'); if (v) v.textContent = прозр.value + '%'; }
    } catch (e) { log.debug('[Объём 3D] снять с кривой:', e.message); }
  };
}

// ============================================================
// ALL TOGGLES
// ============================================================
function bindToggles() {
  // [11.1.35] НАДГРОБИЕ ВТОРОГО ХОЗЯИНА. Этот общий перещёлкиватель молча
  // щёлкал класс И У ТЕХ тумблеров, у которых есть СОБСТВЕННЫЙ обработчик.
  // На «Убрать стол» это давало ровно то, что видел владелец: свой
  // обработчик двигал тумблер и применял отсечение, а следом срабатывал
  // этот и СБРАСЫВАЛ класс назад — отсечение на экране есть, тумблер
  // выглядит выключенным. Та же болезнь, что уже хоронили в appInit
  // (надгробие 10.19.30), только тогда лишним был appInit, а теперь —
  // сам общий перещёлкиватель для тумблеров с хозяином.
  //
  // Правило, а не список имён: тумблер с собственным обработчиком помечает
  // себя data-атрибутом «хозяин» В МОМЕНТ ПРИВЯЗКИ, и общий перещёлкиватель
  // его не трогает. Проверка — в момент КЛИКА, а не привязки: хозяева из
  // других модулей (featureBindings, proFeaturesBindings) вешаются позже
  // этой функции, и проверка при привязке их бы не увидела.
  onAll('.ctrl-toggle', 'click', (e) => {
    if (e.currentTarget.dataset.хозяин) return;
    e.currentTarget.classList.toggle('on');
    // role="switch" обязан говорить правду и читалке экрана, не только глазу.
    e.currentTarget.setAttribute('aria-checked', String(e.currentTarget.classList.contains('on')));
  });
}

// ─── TRANSFER FUNCTION EDITOR ────────────────────────────────
function bindTFEditor() {
  // Callback: применяет пресет-объект к текущему Volume3D viewport
  const applyTF = (presetObj) => {
    const re = getRenderingEngine();
    if (!re) return;
    // Ищем Volume3D viewport
    for (const vpId of getViewportIds()) {
      const vp = re.getViewport(vpId);
      const actorEntry = vp?.getDefaultActor?.() || vp?.getActors?.()[0];
      if (vp && actorEntry?.actor?.getProperty) {
        try {
          const property = actorEntry.actor.getProperty();

          // RGB Transfer Function
          const ctfun = property.getRGBTransferFunction?.(0);
          if (ctfun?.removeAllPoints) {
            ctfun.removeAllPoints();
            for (const [hu, r, g, b] of presetObj.color) ctfun.addRGBPoint(hu, r, g, b);
          }

          // Scalar Opacity
          const ofun = property.getScalarOpacity?.(0);
          if (ofun?.removeAllPoints) {
            ofun.removeAllPoints();
            for (const [hu, alpha] of presetObj.opacity) ofun.addPoint(hu, alpha);
          }

          // Gradient Opacity
          if (presetObj.gradient && property.getGradientOpacity) {
            try {
              const gofun = property.getGradientOpacity(0);
              if (gofun?.removeAllPoints) {
                gofun.removeAllPoints();
                for (const [mag, alpha] of presetObj.gradient) gofun.addPoint(mag, alpha);
              }
              property.setUseGradientOpacity?.(0, true);
            } catch (e) { log.debug('[SidebarBindings]', e.message); }
          } else {
            property.setUseGradientOpacity?.(0, false);
          }

          // Shading
          property.setShade?.(presetObj.shade ?? true);
          property.setAmbient?.(presetObj.ambient ?? 0.2);
          property.setDiffuse?.(presetObj.diffuse ?? 0.8);
          property.setSpecular?.(presetObj.specular ?? 0.2);
          property.setSpecularPower?.(presetObj.specularPower ?? 10);

          vp.render();
        } catch (e) {
          log.warn('[TFEditor] Apply error:', e);
        }
      }
    }
  };

  // Инициализируем редактор
  initTFEditor(applyTF);

  // Click handler is in main.js — no duplicate here
}

// ─── LEFT PANEL VRT → RIGHT PANEL (синхронизация) ─────────────
function bindLeftPanelVRT() {
  // УДАЛЕНО: дублировало bindVRTSection() (строки 310-318)
}

// ─── LEFT PANEL ORIENT → RIGHT PANEL ─────────────────────────
function bindLeftPanelOrient() {
  // УДАЛЕНО: дублировало bindVRTSection() (строки 320-339)
}

// ============================================================
// RULER / MINIMAP
// ============================================================
function bindRulerMinimap() {
  on('toggle-minimap', 'click', () => {
    const mm = $('minimap');
    if (mm) mm.style.display = mm.style.display === 'none' ? 'block' : 'none';
  });
}

// ============================================================
// HANGING PROTOCOLS
// ============================================================
function bindHangingProtocols() {
  on('hanging-protocol', 'change', (e) => {
    const proto = e.target.value;
    const layoutMap = { 'ct-default': 'mpr', 'mr-default': '1x2', 'us-default': '1x1', 'mg-default': '1x2', 'pet-ct': '2x2' };
    if (layoutMap[proto]) changeLayout(layoutMap[proto]);
    else if (proto === 'auto') showToast('Протокол определяется автоматически при загрузке', 'info');
  });
}


// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// ENTERPRISE FEATURES (v6) — W/L History, Clinical Workflows, Quick-apply
// ══════════════════════════════════════════════════════════════

/** @type {Array<{ww:number, wc:number, timestamp:number, label:string}>} */
const _wlHistory = [];
const WL_HISTORY_MAX = 20;

/**
 * Push current W/L to history stack (called internally on every W/L change)
 * @param {number} ww
 * @param {number} wc
 * @param {string} [label='']
 */
export function pushWLHistory(ww, wc, label = '') {
  _wlHistory.push({ ww, wc, timestamp: Date.now(), label });
  if (_wlHistory.length > WL_HISTORY_MAX) _wlHistory.shift();
}

/**
 * Get W/L history
 * @returns {Array}
 */
export function getWLHistory() { return [..._wlHistory]; }

/**
 * Restore previous W/L from history
 * @param {number} [index=-1] — -1 = last
 */
export function restoreWLFromHistory(index = -1) {
  const entry = index < 0 ? _wlHistory[_wlHistory.length + index] : _wlHistory[index];
  if (!entry) { showToast('❌ Нет W/L в истории', 'warning'); return; }
  const re = getRenderingEngine();
  const vp = re?.getViewport(_ctx?.getCurrentViewportId?.());
  if (vp) {
    vp.setProperties({ voiRange: { lower: entry.wc - entry.ww / 2, upper: entry.wc + entry.ww / 2 } });
    vp.render();
    updateWLOverlay(entry.ww, entry.wc);
    showToast(`↩ W:${entry.ww} L:${entry.wc}`, 'info', 1000);
  }
}

/**
 * [11.0.2] ВТОРОЙ РЕЕСТР `CLINICAL_WORKFLOWS` УДАЛЁН — вместе с двумя
 * функциями при нём (`applyClinicalWorkflow`, `listClinicalWorkflows`).
 *
 * Он был мёртв: обе функции экспортировались и не вызывались НИГДЕ — ни в
 * src/, ни в тестах. Но мёртв опасно, по двум причинам сразу.
 *
 * ПЕРВАЯ: он носил имя живого реестра. Настоящий CLINICAL_WORKFLOWS живёт в
 * core/presetsManager.js, и именно из него берут сценарии кнопки «КТ Кости»,
 * «КТ Ангиография» и остальные (`_bindСценарии` ниже, через getWorkflow).
 * Ключи у двух реестров РАЗНЫЕ: здесь были 'bone-ct', 'chest-ct', там —
 * 'workflow-ct-bone', 'workflow-ct-chest'. Тот, кто нашёл бы этот по имени,
 * получил бы другой набор.
 *
 * ВТОРАЯ, и она хуже: здесь лежали ЗАШИТЫЕ ЧИСЛА ОКНА — ww/wc прямо в
 * записях. При этом комментарий к живому связывателю восемьюдесятью строками
 * ниже обещает: «ТОЛЬКО реестр CLINICAL_WORKFLOWS… зашитых чисел здесь нет и
 * не будет (пин в enterprise_test)». Обещание было правдой про то место — и
 * неправдой про этот файл, где числа лежали всё это время.
 */

export function getSidebarBindingsState() {
  // [11.0.2] Поле `workflows` считало записи ВТОРОГО реестра
  // CLINICAL_WORKFLOWS — того самого, что удалён выше как мёртвый и опасный.
  // Ссылку я при удалении проглядел: синтаксис от этого не страдает, файл
  // разбирается, а падало бы на вызове — ReferenceError. Поймано КОНТРОЛЕМ
  // verify_11_0_3, а не глазами, и это ровно то, ради чего он написан.
  //
  // Считаем теперь живой реестр — тот, из которого работают кнопки сценариев.
  return { activeVRTPreset: _activeVRTPreset, builtinPresets: BUILTIN_VRT_PRESETS.length,
    userPresets: getUserVRTPresets().length, wlHistorySize: _wlHistory.length,
    workflows: Object.keys(CLINICAL_WORKFLOWS_РЕЕСТР || {}).length };
}
export function getActiveVRTPreset() { return _activeVRTPreset || ''; }
export function getBuiltinVRTPresets() { return [...BUILTIN_VRT_PRESETS]; }
export function getUserVRTPresetsAPI() { return getUserVRTPresets(); }
/**
 * [10.0.2] Сказать, КУДА лёг пресет. Раньше сообщение было просто названием
 * пресета, и человек не мог понять, почему изменилось не то, что он ждал.
 */
function _presetToast(label, res) {
  const name = String(label || '').trim();
  // [10.0.3] Если пресет пришлось подгонять под шкалу серии или он в неё не
  // попадает — говорим об этом. Молчаливое «применено» на чёрном окне и было
  // тем, что читалось как «пресет не работает».
  if (res?.notice) return `🎨 ${res.notice}`;
  if (res?.target === 'view-3d') return `🎨 ${name} → окно «3D · Пресет»`;
  if (res?.target) return `🎨 ${name} → объёмное окно`;
  if (res?.fallbackWL) return `🎨 ${name} → окно плотности на срезах (объёмного окна в раскладке нет)`;
  return `🎨 ${name}`;
}

export function applyVRTPresetById(presetId) {
  const p = _ctx?.VRT_PRESET_MAP?.[presetId] || { cs3d: presetId, ww: 400, wc: 40 };
  _activeVRTPreset = presetId;
  return applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
}
export function syncCinematicSlidersAPI() { _syncCinematicSliders(); }
export function openVRTPresetManagerAPI() { openVRTPresetManager(); openModal('modal-vrt-presets'); }


// [10.19.43] «Сравнение ракурсов — сделать достойной» (решение владельца,
// п.5): подсветка сохранённых видов честная — из ядра (getCameraABState),
// не из локальных флагов, которые лгали бы после пере-рендера панели.
function _bindРакурсы() {
  const кА = document.getElementById('btn-cam-a');
  const кБ = document.getElementById('btn-cam-b');
  const кАБ = document.getElementById('btn-cam-ab');
  if (!кА || !кБ || !кАБ) return;
  const окно = () => find3DViewportId();
  const свет = () => { const id = окно(); const st = id ? getCameraABState(id) : { a: false, b: false };
    кА.classList.toggle('active', st.a); кБ.classList.toggle('active', st.b); };
  кА.addEventListener('click', () => { const id = окно(); if (!id) { showToast('Нет объёмного окна — откройте MPR 6 или 3D', 'info', 1800); return; } setCameraA(id); showToast('🅰 Вид А сохранён', 'success', 1000); свет(); });
  кБ.addEventListener('click', () => { const id = окно(); if (!id) { showToast('Нет объёмного окна — откройте MPR 6 или 3D', 'info', 1800); return; } setCameraB(id); showToast('🅱 Вид Б сохранён', 'success', 1000); свет(); });
  кАБ.addEventListener('click', async () => { const id = окно(); if (!id) { showToast('Нет объёмного окна', 'info', 1500); return; }
    const st = getCameraABState(id);
    if (!st.a || !st.b) { showToast('Сначала сохраните Вид А и Вид Б', 'info', 2000); return; }
    await toggleCameraAB(id); свет(); });
  свет();
}

// [10.19.43] Сценарии — переезд из Enterprise (п.8). ТОЛЬКО реестр
// CLINICAL_WORKFLOWS: пресет 3D по имени записи и окно по имени пресета
// окна; зашитых чисел здесь нет и не будет (пин в enterprise_test).
function _bindСценарии() {
  const ряд = document.getElementById('wf-row');
  if (!ряд) return;
  ряд.addEventListener('click', (e) => {
    const к = e.target.closest('[data-workflow]');
    if (!к) return;
    const wf = getWorkflow(к.dataset.workflow);
    if (!wf) { showToast('Сценарий не найден в реестре', 'error', 2000); return; }
    const применено = [];
    const окно3д = find3DViewportId();
    if (wf.preset3d?.id && окно3д) { try { set3DPreset(wf.preset3d.id); применено.push('3D'); } catch (err) { /* пресет 3D — не повод ронять окно */ } }
    const wp = wf.window?.id ? getWindowPreset(wf.window.id) : null;
    if (wp && wp.ww != null) { applyWindowToSlices({ ww: wp.ww, wc: wp.wc }); применено.push(`окно ${wp.ww}/${wp.wc}`); }
    showToast(`${wf.name}${применено.length ? ' · ' + применено.join(' + ') : ' — подходящих окон нет'}`, применено.length ? 'success' : 'info', 2200);
  });
}
